import 'regenerator-runtime/runtime'
import React from 'react';
import FaPlusCircle from 'react-icons/lib/fa/plus-circle';
import FaMinusCircle from 'react-icons/lib/fa/minus-circle';
import formatNumbers from 'util/formatNumbers';
import config from '../../../config';
import Select from 'react-select';
import {v4 as uuidv4} from 'uuid';
import {getModelVariationsForUPCCode} from 'dashboard/processing/3PLSharedMethods';
import Colors from 'util/Colors';
import ReportWrongUPCButton from 'dashboard/processing/ReportWrongUPCButton';
import {isPartner} from 'dashboard/services/partners/Partner'
import FaCircle from 'react-icons/lib/fa/circle';
import FaCircleO from 'react-icons/lib/fa/circle-o';
import {base64ToHex, generateMongoObjectID, hexToBase64, prepareSelectOptionsList} from 'util/Utils';
import moment from 'moment';
import classNames from 'classnames';
import {
    displayVariationsSortingToggle,
    resetTrackedTime,
    saveTimeTrackingLog,
    startTimeTrackingByUser,
    stopAndStartTimeTracking
} from 'shared/sharedMethods';
import {FETCH_ALL_SELLER_PICKUPS_LIST, UPDATE_APP_DATA} from 'actions/actionTypes';
import {Button, Checkbox, Col, FormControl, Modal, Row} from 'react-bootstrap';
import _ from 'lodash';
import {getAllowedAgeGroups} from '../../shared/sharedMethods';

var async = require('async');
var mime = require('mime-types');

export const  dispositionOptionsList = [
     {value: 'openbox_used', number:1, label:'Sellable - Open Box/Used'},
     {value: 'refurbish_parts',number:2, label:'Sellable - Refurbish/Parts'},
     {value: 'salvage', number:3, label:'Dispose - Damaged/Recalled'},
     {value: 'new_condition', number:4, label:'Sellable -  New, Unopened'},
 ]
 export const  SCREENS = {
     service_selection_screen: {
         title: 'Services list',
         key:'service_selection_screen'
     },
     parcel_pallet_screen: {
         title: 'Pallet / Parcel',

         key:'parcel_pallet_screen'
     },
     tracking_number_quantity_screen: {
         getTitle: (component)=> {
             return component.FeatureFlags.Processing3PLByManager ? 'Add Quantity' : 'Add new item';
         },
         key:'tracking_number_quantity_screen'
     },
     parcel_pallet_scanning_screen: {
         getTitle: (component)=> {
              return  component.state.screensData.PalletType + ' scanning';
         },
         key:'parcel_pallet_scanning_screen'
     },
     conditions_screen: {
         title: 'Condition',
         key:'conditions_screen'
     },
     item_failed_quality_check_screen: {
         title: 'Item failed quality check',
         key:'item_failed_quality_check_screen'
     },
     instructions_screen: {
         title: 'Instructions',
         key:'instructions_screen'
     },
     instructions_details_screen: {
         title: 'Instuctions Details',
         key:'instructions_details_screen'
     },
     categories_screen: {
         title: 'Categories',
         key:'categories_screen'
     },
     quantity_selection: {
         title: 'Quantity',
         key:'quantity_selection'
     },
     quality_checks_screen: {
         title: 'Quality Checks',
         key:'quality_checks_screen'

     },
     product_options_screen: {
         title: 'Amazon',
         key:'product_options_screen'
     },
     fees_screen: {
         title: 'Fees',
         key:'fees_screen'
     },
     service_listings_completion: {
         title: 'Service',
         key:'service_listings_completion'
     },
     confirmation_screen: {
         title: 'Confirmation',
         key:'confirmation_screen'
     },
     barcode_printing_screen: {
         title: 'Barcode',
         key: 'barcode_printing_screen'

     },
     pallet_confirmation_screen: {
         title: 'Pallet Confirmation',
         key: 'pallet_confirmation_screen'
     },
     pallet_dispute_screen: {
         title: 'Pallet Dispute',
         key: 'pallet_dispute_screen'
     },
     posting_pallet_product_screen: {
         title: '',
         key: 'posting_pallet_product_screen'
     },
     pallet_product_variation_screen: {
         title: 'Add Variation',
         key: 'pallet_product_variation_screen'
     },
     location_scanning_screen: {
         title: 'Location Scanning',
         key:'location_scanning_screen'
     },
     gbg_product_selection_screen: {
         title:'Search GBG Products',
         key :'gbg_product_selection_screen'
     },
     listing_selection_screen: {
         title:'Search Listings',
         key :'listing_selection_screen'
     },
     rma_products_selection_screen: {
         title:'Search RMA products',
         key :'rma_products_selection_screen'
     },
     gbg_product_details_screen: {
         title: 'Verify GBG Product',
         key:'gbg_product_details_screen'
     },
     barcode_scanning_screen: { /*posting*/
         title: 'Barcode scanning',
         key:'barcode_scanning_screen'
     },
     create_product_screen: { /*posting*/
         title: 'Photos',
         key:'create_product_screen'
     },
     choose_action_screen: { /*posting*/
         title: 'Actions',
         key:'choose_action_screen'
     },
     inbound_rebound_screen: {
        title: 'Inbound Rebound',
        key:'inbound_rebound_screen'
     },
     inbound_rebound_add_inventory: {
        title: 'Add Inventory',
        key: 'inbound_rebound_add_inventory'
     }
 }
 export const allFeesList = [
     {
         feeType: 'BatteryFee', label: 'Battery', additionalLabel: ': $5'
     },
     //   {feeType: 'LaundryFee', additionalLabel: ': $5'},
     {
         feeType: 'ReassemblyFee',
         label: 'Re-assembly',
         additionalLabel: ': $5',
     },
     {
         feeType: 'ReplacementPart',
         label: 'Replacement Part',
         additionalLabel: ': $5, $10, $15, $20',
         amount: 5,
         amounts: [5, 10, 15, 20]
     },
     {
         feeType: 'CleaningFee',
         label: 'Cleaning',
         additionalLabel: ': $5, $10, $15',
         amount: 5,
         amounts: [5, 10, 15]
     },
 ]

 export function prepareProductTags(dataToSave) {


     if (_.get(this.state.screensData, ['HotBuy'], false)) {
         dataToSave.ProductTags.push('hotBuy')
     }
     if (_.get(this.state.screensData, ['ProductAgeRange'], []).length) {
         var productAgeTagsPrefixed = _.map(_.filter(dataToSave['ProductAgeRange'], function (tag) { /* convert Age group to tags used in Shopify */
             return _.includes(_.map(getAllowedAgeGroups(),'value'), tag)
         }), function (ageGroupTag) {
             if (ageGroupTag == 'Gradeschool') {
                 return 'Age Group_Grade School';
             } else {
                 return 'Age Group_' + ageGroupTag;
             }
         });
         dataToSave['ProductTags'] = dataToSave['ProductTags'].concat(productAgeTagsPrefixed)
     }
     if (_.includes(['OpenBoxMinorIssues', 'GentlyUsedMinorIssues'], _.get(_.find(config.conditionsData, {number: this.state.screensData['Condition']}), 'value', ''))) {
         dataToSave['ProductTags'].push('with issues')
     }
     dataToSave['ProductTags'].push('Condition_' + dataToSave['Condition'])
     if (dataToSave['Details']) {
         dataToSave['ProductTags'].push('details-' + dataToSave['Details'].replace(/,/g, '&#44;'))
     }
     var Categories = _.get(dataToSave, ['Categories'], [])
     _.forEach(Categories, function (item) {
         dataToSave.ProductTags.push(item.Category)
         if (_.get(item, 'Subcategory')) {
             dataToSave.ProductTags.push(item.Subcategory)
         }
     })
     if (_.get(this.state.screensData,'confirmDimensions') == 'box_size_selected'){ /* after box size is selected from the popup*/
         var selectedBoxSize =_.find(config.boxSizeList,item=>{
             return  item.data.Length ==_.get(this.state.screensData.productDimensions, 'Length') &&
                 item.data.Width ==_.get(this.state.screensData.productDimensions, 'Width') &&
                 item.data.Height ==_.get(this.state.screensData.productDimensions, 'Height')
         })
         console.log('selectedBoxSize', selectedBoxSize  );
         if (_.get(selectedBoxSize, 'value') =='Mailer'){
             dataToSave['ProductTags'].push('Box_Mailer')
         }else {
             dataToSave['ProductTags'].push('Box_' + this.state.screensData.productDimensions['Length'] + 'x' + this.state.screensData.productDimensions['Width'] + 'x' + this.state.screensData.productDimensions['Height'])
         }
         // _.set(dataToSave, 'OriginalGBGProductDataToUpdate',_.extend(_.get(dataToSave, 'OriginalGBGProductDataToUpdate', {}),{OriginalProductCustomData:{DimensionsConfirmed: true}}))
     }else{
         var boxSizeTag  =  _.find(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), function (tag) {
             return _.includes(tag, 'Box_')
         })

         if (boxSizeTag){
             dataToSave.ProductTags.push(boxSizeTag)
         }else if(_.get(this.state.screensData, ['OriginalProductDimensions', 'Length'])){
             console.log('OriginalProductDimensions',  _.get(this.state.screensData, ['OriginalProductDimensions'], []) );
             var dimensionProductSize = _.find(config.boxSizeList, item=>{
                 return  item.compareWithProductDimensions &&  item.data.Length == _.get(this.state.screensData, ['OriginalProductDimensions', 'Length']) && item.data.Width ==_.get(this.state.screensData, ['OriginalProductDimensions', 'Width']) && item.data.Height ==  _.get(this.state.screensData, ['OriginalProductDimensions', 'Height'])
             }  )
             if(dimensionProductSize){
                 dataToSave.ProductTags.push('Box_'+dimensionProductSize.value)

             }
         }
     }

    // }
     if(_.size(_.get(this.state.screensData, ['GBGProductTagsToAssign'], []))){
         dataToSave.ProductTags =dataToSave.ProductTags.concat(_.map(_.get(this.state.screensData, ['GBGProductTagsToAssign'], []), 'value'))
         console.log(' dataToSave.ProductTags',  dataToSave.ProductTags  );
     }
 }
 export function fetchGBGProductsTags() {
     var self = this;
     var methodData = {
         "endpoint": "/settings",
         timeout:27000,
         'not_display_error_message': true,
     }
     this.props.makeRequest({include:['updatedAt'], Name: 'GBGProductTagsList'}, methodData).then(function (res) {

         if (_.isUndefined(_.get(self.props.appData, 'GBGProductTags.updatedAt')) || (!moment(_.get(res.data.data, '0.updatedAt')).isSame(moment(self.props.appData.boxSizeData.updatedAt)))) {
             self.props.makeRequest({ Name: 'GBGProductTagsList'},methodData).then(function (res) {

                 if(_.get(res.data.data, '0._id')) {
                     return  self.props.dispatchAction({
                         'GBGProductTags': {
                             updatedAt: _.get(res.data.data, '0.updatedAt',),
                             GBGProductTagsList: _.get(res.data.data, '0.Data.GBGProductTags',[])
                         },
                     }, UPDATE_APP_DATA)
                 }
             })
         }
     }).catch(err => {
     });

 }
 export function searchAmazonProducts(params) {
     var self = this;

     return new Promise(function (resolve) {
         var methodData = {
             'endpoint': '/get-amazon-products',
             'not_display_success_message': true,
             'not_display_error_message': true,
             timeout: 45000,
         };


         var dataToSave = {
             useSearchAPI: '',
               OriginalPrice: ''
         };

         self.props.makeRequest({term: params.term}, methodData).then(function (response) {
             dataToSave.searchAPIProductsFetched = true
             dataToSave.searchAPIProducts = response.data.data;
              dataToSave.SearchTerm =params.term;
             dataToSave['SearchTermBrand'] = params.Brand
             dataToSave['SearchTermModel'] = params.Model
             resolve( dataToSave )

         }).catch(function (error) {
             // sendEvent('Amazon Product Not Found', {'term': term});
             console.log('error search amazon', error);
             dataToSave.searchAPIProducts = []

             // var externalImageIndex = _.findIndex(_.get(self.state.screensData, 'images', []), function (image) {
             //     return _.get(image, ['type'], '') == 'External' && _.get(image, ['CustomImageData', 'Source'], '') == 'AmazonProduct'
             // });
             // if (externalImageIndex !== -1) {
             //     dataToSave['images'] = [..._.get(self.state.screensData, 'images', [])]
             //     _.pullAt(dataToSave['images'], [externalImageIndex])
             //     /* delete previous external image */
             // }


             resolve( dataToSave)

         })
     })
 }
 export function prepareDataForWeight(dataToUpdate){
     const {ProductCategories = [], OverrideShippable = false, Shippable = false} = this.state.screensData
     const overrideCategory = ProductCategories.find(item => {
         return (['Strollers'].includes(item.Category) &&  !['StrollerAccessories'].includes(item.Subcategory)) || ['carseat'].includes(item.Category)
     })
     if (dataToUpdate['Weight'] > 10 &&  !OverrideShippable && !overrideCategory) {
         dataToUpdate.Shippable = false;
         /* if weight more than 10lb, set Shippable to false */
         /* if item is related to a stroller or a car seat, Shippable tag is set based only on selected Shippable option*/
     }
     if (!Shippable && dataToUpdate['Weight'] < 10) {   /* if Shippable is false and Weight is less than 10 or not specified,  always set Weight to 11 lb*/
         dataToUpdate.Weight = 11;
     }
     if (Shippable) {
         dataToUpdate['ProductTags'].push('Shipping Options_Shippable')
     } else {
         _.pull(dataToUpdate.ProductTags, 'Shipping Options_Shippable')
     }
     dataToUpdate['ProductTags'] = _.uniq(dataToUpdate['ProductTags'])
 }

 export function prepareAmazonProductData() {
     var AmazonProductData = {}
     AmazonProductData.AmazonProductFoundByASIN = _.get(this.state.screensData, 'selectedSearchAPIProduct.AmazonProductFoundByASIN', false)
     if (this.state.screensData.selectedSearchAPIProduct.name !== 'title_not_found') {
         AmazonProductData['OriginalDescription'] = this.state.screensData.selectedSearchAPIProduct.name;
     }
     AmazonProductData['OriginalUrl'] = _.get(this.state.screensData.selectedSearchAPIProduct, 'OriginalUrl')
     AmazonProductData['ASIN'] = _.get(this.state.screensData.selectedSearchAPIProduct, 'ASIN')
     AmazonProductData['UPC'] = _.get(this.state.screensData.selectedSearchAPIProduct, 'UPC')
     AmazonProductData['ISBN'] = _.get(this.state.screensData.selectedSearchAPIProduct, 'ISBN')
     if (this.state.screensData.selectedSearchAPIProduct.price !== 'price_not_found') {
         AmazonProductData['AmazonProductPrice'] = formatNumbers.unformat(this.state.screensData.selectedSearchAPIProduct.price)
     }
     AmazonProductData['rawAmazonProductData'] = _.get(this.state.screensData.selectedSearchAPIProduct, 'rawAmazonProductData')
     if (_.get(this.state.screensData.selectedSearchAPIProduct, 'rawAmazonProductData')) {
         AmazonProductData['rawAmazonProductData'] = this.state.screensData.selectedSearchAPIProduct.rawAmazonProductData;
         AmazonProductData['SearchTerm'] = this.state.screensData.SearchTerm;
         AmazonProductData['SearchTermBrand'] = this.state.screensData.SearchTermBrand;
         AmazonProductData['SearchTermModel'] = this.state.screensData.SearchTermModel;
     } else {
         AmazonProductData['ASIN'] = ''
     }
     //  }

     if ( _.get(this.state.screensData, 'selectedSearchAPIProduct.Weight', false)) {
         AmazonProductData['Weight'] = this.state.screensData.selectedSearchAPIProduct.Weight;
         if (_.includes(['hundredths-pounds', 'Hundredths Pounds'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) {
             AmazonProductData['Weight'] = AmazonProductData['Weight'] / 100
         }
         if (_.includes(['Kilograms'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) { /* convert kilograms to pounds */
             AmazonProductData['Weight'] = AmazonProductData['Weight'] * 2.20462;
         }
         if (_.includes(['Ounces'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) { /* convert ounces to pounds */
             AmazonProductData['Weight'] = AmazonProductData['Weight'] / 16
         }
         if (_.includes(['Grams'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) { /* convert grams to pounds */
             AmazonProductData['Weight'] = AmazonProductData['Weight'] * 0.00220462;
         }
         if (_.includes(['Milligrams'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) { /* convert milligrams to pounds */
             AmazonProductData['Weight'] = AmazonProductData['Weight'] * 0.00000220462;
         }
         if (_.includes(['ounces'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) { /* convert ounces to pounds */
             AmazonProductData['Weight'] = AmazonProductData['Weight'] / 16
         }
         if (!_.includes(['lb', 'Kilograms', 'Grams', 'Milligrams', 'ounces', 'hundredths-pounds', 'Hundredths Pounds', 'pounds', 'Pounds'], this.state.screensData.selectedSearchAPIProduct.WeightUnit)) {
             AmazonProductData['WeightUnit'] = this.state.screensData.selectedSearchAPIProduct.WeightUnit
             /* this WeightUnit is not saved in GBG Product and it is used only to check if unknown weight unit is used*/
         }

     }
     _.forEach(['Height', 'Width', 'Length'], (key) => {
         if (_.get(this.state.screensData.selectedSearchAPIProduct, key)) {
             if (_.includes(['inches', 'Inches', 'Centimeters', 'hundredths-inches', 'Hundredths Inches'], _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']))) {
                 AmazonProductData[key] = _.get(this.state.screensData.selectedSearchAPIProduct, key)
                 AmazonProductData[key + 'Unit'] ='inches'
                 if (_.includes(['hundredths-inches', 'Hundredths Inches'], _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']))) {
                     AmazonProductData[key] =  AmazonProductData[key] / 100;
                 } else if (_.includes(['Centimeters'], _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']))) {
                     AmazonProductData[key] = AmazonProductData[key] / 2.54;
                 }
             }
         }})
     return AmazonProductData
 }
 export function searchProductsWithAPI(params={}) {
     return new Promise((resolve, reject) => {
         var self = this;

try {
    var Brand = _.get(self.state.screensData, 'selectedGBGProduct.Brand','')

    var Model = _.get(self.state.screensData, 'selectedGBGProduct.Model','')
    var term = Brand + ' ' + Model
    if (_.get(params, 'useSearchAPI', _.get(self.state.screensData, ['useSearchAPI'])) == 'SerpAPI' || (_.size(_.get(self.state.screensData, ['similarProducts'], [])) == 0 && _.includes(['ikea', 'b. toys', 'our generation'], Brand.toLowerCase()))) {
        searchWithSerpAPI.call(this, {term: term, Brand: Brand, Model: Model}).then((data) => {
            resolve(data)
        })
    } else {
        searchAmazonProducts.call(this, {term: term, Brand: Brand, Model: Model}).then((data) => {
            console.log('search amazon response', data)
            resolve(data)
        })
    }
}catch (e){
    console.log('e', e  );
}

     })
 }
 export function  displayProductImages() {

     var imageToDisplay =_.get(this.state.screensData,'images.0.fullUri')

     if(!imageToDisplay){
         return null
     }
     return  <div
         className=" ">
         <img  style={{width:100, height: '100%'}}   src={imageToDisplay}  />

     </div>
 }
 function searchWithSerpAPI(data) {
     return new Promise((resolve, reject) => {
         var self = this;
         var dataToSave = {
               useSearchAPI: 'SerpAPI',
             selectedSearchAPIProduct: {},
             searchAPIProducts: [],

             OriginalPrice: ''
         };
         dataToSave['SearchTermBrand'] = data.Brand
         dataToSave['SearchTermModel'] = data.Model
         dataToSave['SearchTerm'] = data.term

         var methodData = {
             'endpoint': '/search-products',
             timeout: 30000,
             'not_display_success_message': true,
             'not_display_error_message': true,
         };

         self.props.makeRequest({term: data.term, 'type': 'google_serpapi'}, methodData).then(function (response) {

             dataToSave.searchAPIProducts = response.data.data
            resolve(dataToSave)

         }).catch(function (error) {

             console.log('error', error);
             resolve(dataToSave)

         })
     })
 }

 export function displayQualityCheckItems(stateData) {
     var self = this
     var foundItemIndex = _.findIndex(stateData.qualityCheckItems, (qualityCheckItem) => {
         return _.get(stateData, 'currentQualityCheckRecord._id') == qualityCheckItem._id
     });
     var chunkedQualityChecks =_.chunk(stateData.qualityCheckItems,10)
     if (foundItemIndex ==-1){
         return null
     }
     const {QualityCheckImages=[]} =   stateData.currentQualityCheckRecord

     return (<div style={{

         marginTop:15,
         marginBottom: 30,
     }}>
         {_.map(chunkedQualityChecks, function (items, outerIndex) {
             return <div key={outerIndex} style={{  }}>
                 { _.map(items, function (item, index) {
                     const displayItemIndex = _.findIndex(stateData.qualityCheckItems, (qualityCheckItem) =>
                         item._id == qualityCheckItem._id);

                     var itemColor = Colors.lightBlue
                     if (stateData.currentQualityCheckRecord._id == item._id){
                         itemColor= Colors.lightBlue

                     }
                     if (item.checkedStatus =='failed'){
                         itemColor= Colors.red
                     }
                     if (item.checkedStatus =='passed'){
                         itemColor=  Colors.green
                     }

                     return <span key={index} style={{marginBottom:2,  }}>
                            <span

                                onClick={() => {
                                    console.log('on press'   );
                                    self.setScreensData({
                                        currentQualityCheckRecord: stateData.qualityCheckItems[displayItemIndex]
                                    })
                                }}
                                style={{

                                    marginRight:6,
                                }}>
                                {(stateData.currentQualityCheckRecord._id == item._id && item.checkedStatus &&chunkedQualityChecks.length-1 ==outerIndex && items.length-1 ==index ) || (stateData.currentQualityCheckRecord._id == item._id && !item.checkedStatus) || (item.checkedStatus && stateData.currentQualityCheckRecord._id !== item._id) ?
                                    <FaCircle style={{'color': itemColor, fontSize: 16}}/> :
                                    <FaCircleO style={{'color': itemColor, fontSize: 16}}/>
                                }

                            </span>

                        </span>})}
             </div>

         }) }
         <div  style={{    marginTop:15,  }}>
             <div className="font-size-19 bot30  top30" style={{height:100}}>
                 {stateData.currentQualityCheckRecord.Text +(config.getEnvironmentName() == 'production' ? '': ' ' + _.get(stateData.currentQualityCheckRecord,'ItemNumber','') )}
             </div>
             {QualityCheckImages.map((image,index)  => {
                 return <span style={{
                     'border-radius':10,
                 }}  key={index} className="pright15"><img
                   className="bot20"
                   style={{
                        'max-height': 350,
                       'max-width':'100%',
                   }}  src={ image.URL}/></span>
             })}
             <div     style={{display:'flex', flexDirection: 'row',  marginTop:10, marginBottom:30,  alignItems:'flex-end',justifyContent: 'space-evenly',}}>

                 <Checkbox
                   //  disabled={this.state.pending}
                     onChange={(e) => {
                         console.log('on change'   );
                     self.setScreensData({
                         qualityCheckItems: [...stateData.qualityCheckItems.slice(0, foundItemIndex),
                             {...stateData.qualityCheckItems[foundItemIndex], checkedStatus:'passed' },
                             ...stateData.qualityCheckItems.slice(foundItemIndex + 1)],
                         currentQualityCheckRecord:{...stateData.qualityCheckItems[foundItemIndex], checkedStatus:'passed'}
                     }, ()=> {
                         setTimeout(() => {

                             if (stateData.qualityCheckItems[foundItemIndex + 1]) {
                                 self.setScreensData({
                                     currentQualityCheckRecord: stateData.qualityCheckItems[foundItemIndex + 1]
                                 })
                             } else {
                                 var failedQualityCheckItems =_.filter(_.get(self.state.screensData, 'qualityCheckItems', []), item => {
                                     return item.checkedStatus == 'failed'
                                 })

                                 var dataToSave = prepareDataForScreen.call(self),nextScreen =SCREENS.fees_screen.key
                                  if( self.state.currentFlow == '3PLProcessingFlow' ){
                                   //  if (_.get(self.state.screensData.CurrentPartnerProductData, '_id')){
                                      //   nextScreen =SCREENS.location_scanning_screen.key
                                     // } else{
                                     //     nextScreen =SCREENS.fees_screen.key
                                     // }
                                 }

                                 if (_.size(_.get(dataToSave, 'QualityCheckInstructions', [])) > 0 ) {
                                     nextScreen = SCREENS.instructions_screen.key
                                 } else if(self.state.currentFlow == '3PLProcessingFlow' && failedQualityCheckItems.length){
                                      nextScreen = SCREENS.instructions_screen.key
                                      dataToSave.QualityCheckInstructions = [{'Action': 'DONATE'}]
                                 }
                                 self.setScreensData(dataToSave,
                                     function () {
                                     console.log('before go to next' ,nextScreen  );
                                         self.goToNextScreen(nextScreen,{screenDataToSet:{currentQualityCheckRecord:_.first(self.state.screensData.qualityCheckItems)}})


                                     })
                             }
                         }, 1)
                     })

                 }}

                           checked={stateData.currentQualityCheckRecord.checkedStatus=='passed' ? true:false}
                 ><span style={ _.extend({
                         position:'relative',
                         top:-1,
                         color: Colors.green,
                     },
                     stateData.currentQualityCheckRecord.checkedStatus=='passed'  ? {color: Colors.green} : {color: 'black'})
                 }> {'Pass'} </span></Checkbox>



                 <Checkbox
                     onChange={() => {
                         self.setScreensData({
                             qualityCheckItems: [...stateData.qualityCheckItems.slice(0, foundItemIndex),
                                 {...stateData.qualityCheckItems[foundItemIndex], checkedStatus:'failed' },
                                 ...stateData.qualityCheckItems.slice(foundItemIndex + 1)],
                             currentQualityCheckRecord:{...stateData.qualityCheckItems[foundItemIndex], checkedStatus:'failed'}
                         }, ()=>{
                             setTimeout(() => {

                                 if (stateData.qualityCheckItems[foundItemIndex+1]){
                                     self.setScreensData({
                                         currentQualityCheckRecord:stateData.qualityCheckItems[foundItemIndex+1]
                                     })
                                 } else{
                                     var dataToSave =prepareDataForScreen.call(self), nextScreen =SCREENS.fees_screen.key
                                     console.log('QualityCheckInstructions fail', _.get(dataToSave, 'QualityCheckInstructions', [])  );
                                     if (_.size(_.get(dataToSave, 'QualityCheckInstructions', [])) > 0 ) {
                                         nextScreen = SCREENS.instructions_screen.key
                                     }
                                     if( self.state.currentFlow == '3PLProcessingFlow' ) {
                                         nextScreen = SCREENS.instructions_screen.key
                                         if (_.size(_.get(dataToSave, 'QualityCheckInstructions', [])) == 0) {
                                             dataToSave.QualityCheckInstructions = [{'Action': 'DONATE'}]
                                         }
                                     }

                                     self.setScreensData(dataToSave,
                                         function () {
                                             self.goToNextScreen(nextScreen,{screenDataToSet:{currentQualityCheckRecord:_.first(self.state.screensData.qualityCheckItems)}})

                                         })
                                 }
                             }, 1)
                         })
                     }}

                     checked={stateData.currentQualityCheckRecord.checkedStatus=='failed' ? true:false}><span style={ _.extend({
                         position:'relative',
                         top:-1,
                         color: Colors.red,
                     },
                     stateData.currentQualityCheckRecord.checkedStatus=='failed'  ? {color: Colors.red} : {color: 'black'})
                 }> {'Fail'} </span></Checkbox>

             </div>


         </div>
     </div>)

 }
 export function getSimilarProducts(params, ) {
     return new Promise((resolve, reject) => {
         var self = this
         if (!_.get(params, 'selectedGBGProduct._id') || _.get(this.state.screensData, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle') {
             return resolve({
               // similarProducts: [], /* do not search similar products for bundles*/
                 allSimilarProducts: []
             })
         }
         // if (_.isUndefined(params.forceRequest) && _.get(this.state.screensData, ['allSimilarProducts'], []).length) {
         //     var allSimilarProducts = _.get(this.state.screensData, ['allSimilarProducts'], [])
         // } else {
         console.log('getSimilarProducts make request '    );

                     self.props.makeRequest({
                         GBGProductID: params.selectedGBGProduct._id,
                         perPage: 300,
                         status: 'all',
                         sortBy: 'createdAt:-1',
                         quantity: 'all',
                         lookup: ['SaleTransactions'],
                         addFields: ['PublishedInShopifyChangeLogRecord', 'LatestSaleTransaction'],
                     }, {
                         'endpoint': '/products',
                         timeout: 45029,
                         'not_display_success_message': true,
                     }).then(function (response) {
                         resolve({allSimilarProducts:response.data.data})
                     }).catch(function (error) {
                         reject(error)
                     })
                 })
   }
 export function processSimilarProducts(params, ) {


         var allSimilarProducts = _.reject(params.allSimilarProducts, item => {/* exclude products with incorrect Conditon value*/
             return  !_.find(config.conditionsData, {value:item.Condition})
         })
         var similarProducts = []
         //   console.log('allSimilarProducts.length', allSimilarProducts.length  );
         var similarProductsByCondition = _.filter(allSimilarProducts, item => {
             return item.Condition == _.get( _.find(config.conditionsData, {number:params.Condition}), 'tag', '')
         })
         //   console.log('similarProductsByCondition 1', similarProductsByCondition.length  );
         _.forEach(allSimilarProducts, function (item) {
             // var transactionsSorted = _.orderBy(_.get(item, 'SaleTransactionRecords', []), function (item) {
             //     return item.createdAt
             // }, 'desc')
             //
             // var sortedArray = _.sortBy(_.get(item, 'SaleTransactionRecords', []), function (record) {
             //     return new Date(record.createdAt);
             // });
             // var lastSaleTransaction = _.findLast(sortedArray, (transaction) => {
             //     return  transaction.Status !== 'Returned'
             // })
             var lastSaleTransaction = _.get(item, 'LatestSaleTransaction')
             if (_.get(item, 'LatestSaleTransaction._id')) {/* both Active and Inactive products that were sold are counted */
                 item.SimilarProductStatus = 'Sold'
                 item.SimilarProductSoldAt = lastSaleTransaction.SoldAt;
                 var changeLogFound = _.find(_.get(item, 'ChangeLog', []), (changeLog) => {
                     if (_.get(changeLog, 'FieldChanged', '') == 'Status' && _.get(changeLog, 'From', '') == 'Inactive' && _.get(changeLog, 'To', '') == 'Active') { /* PublishedInShopify does not exist in products added before 12.2018 */
                         return true
                     }
                 })

                 if (changeLogFound) {
                     var publishedInShopify = _.get(changeLogFound, 'CustomData.PublishedInShopify', false) ? changeLogFound.CustomData.PublishedInShopify : changeLogFound.Date


                     item.TimeToSell = moment(lastSaleTransaction.SoldAt).diff(publishedInShopify, 'days')
                     item.SellingSeason = _.findKey(config.seasonToMonthMap, (item) => {
                         return _.includes(item.months, parseInt(moment(lastSaleTransaction.SoldAt).format('M')))
                     })
                 }
                 //   console.log('item sale', item.ShopifyProductID, lastSaleTransaction.Amount, item.Price);

                 item.Price = lastSaleTransaction.Amount
                 /* this is not considering DiscountApplied*/
                 similarProducts.push(item)
             } else if (item.Status == 'Active') { /* Active items that were not sold */
                 item.SimilarProductStatus = 'Live'
                 similarProducts.push(item)
             }
         })
         console.log('similarProducts.length', similarProducts.length  );


           return config.getEnvironmentName() == 'local1'  ? []:_.orderBy(similarProducts, ['Price'], ['desc'])
            // allSimilarProducts: config.getEnvironmentName() == 'local1'  ? []:allSimilarProducts



 }

 export function getAmazonProductData(ASIN, dataToUpdate) {
     return new Promise((resolve, reject) => {
         if (ASIN && !this.doNotLookUpForAmazonProducts) {
             /* search Amazon Product by ASIN to compare its price with the stored one*/

             this.props.makeRequest({ASIN: ASIN}, {
                 'endpoint': '/get-amazon-products',
                 'not_display_success_message': true,
                 'not_display_error_message': true,
                 timeout: 25030,
             }).then(searchAmazonProductResponseData => {
                 var searchAmazonProductResponse =_.get(searchAmazonProductResponseData.data, 'data.0', false);
                 console.log('searchAmazonProductResponse', searchAmazonProductResponse);
                 if (searchAmazonProductResponse) {
                     if (searchAmazonProductResponse.price !== 'price_not_found') {
                         dataToUpdate.selectedSearchAPIProduct = searchAmazonProductResponse
                         dataToUpdate.selectedSearchAPIProduct.AmazonProductFoundByASIN = true;
                         dataToUpdate.OriginalPrice = searchAmazonProductResponse.price
                     }
                      var GBGProductImage = _.find(dataToUpdate.images, function (image) {
                         return _.get(image, ['CustomImageData', 'Source'], '') == 'GBGProductImage'
                     });
                     var externalImageIndex = _.findIndex(dataToUpdate.images, function (image) {
                         return _.get(image, ['type'], '') == 'External' && _.get(image, ['CustomImageData', 'Source'], '') == 'AmazonProduct'
                     });
                     if (searchAmazonProductResponse.img !== 'image_not_found' && _.get(dataToUpdate.images, [externalImageIndex, 'fullUri'], 'n/a') !== searchAmazonProductResponse.img) {
                         _.pullAt(dataToUpdate['images'], [externalImageIndex])
                         /* delete previous external image, if any */
                         console.log('GBGProductImage', GBGProductImage  );
                         if (!GBGProductImage) { /* add External image only if GBGProduct image is not yet added*/
                             dataToUpdate['images'].push({
                                 'fullUri': searchAmazonProductResponse.img,
                                 uploadProgress: 1,
                                 imageID: generateMongoObjectID(),
                                 type: 'External',
                                 CustomImageData: {Source: 'AmazonProduct'},
                             })
                         }
                     }
                 } else if (!_.isUndefined(_.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'AmazonProductPrice']))) {
                     dataToUpdate.OriginalPrice = _.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'AmazonProductPrice'])
                 }
                 /* RetailProductPrice overrides new or stored Amazon product price */
                 if (!_.isUndefined(_.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice']))) {
                     dataToUpdate.OriginalPrice = _.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice'])
                 }
                 if (_.get(dataToUpdate, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle') {
                     dataToUpdate.OriginalPrice = ''
                     /* user must specify Retail price for bundles */
                 }
                 resolve(dataToUpdate)
             }).catch(err => {
                 console.log('err', err);
                 resolve(dataToUpdate)
             })
         }else {
             /* RetailProductPrice overrides new or stored Amazon product price */
             if (!_.isUndefined(_.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice']))) {
                 dataToUpdate.OriginalPrice = _.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice'])
             }
             if (_.get(dataToUpdate, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle') {
                 dataToUpdate.OriginalPrice = ''
                 /* user must specify Retail price for bundles */
             }
             resolve(dataToUpdate)
         }

     })
 }
 export function prepareProductAgeRange(data) {
     var ProductAgeRange = []
     //console.log('prepareProductAgeRange',data   );
     const ageGroups = getAllowedAgeGroups();

         if (_.size(_.get(data, 'selectedGBGProduct.AgeGroups', []))) {
             ProductAgeRange = _.map(_.get(data, 'selectedGBGProduct.AgeGroups', []), function (item) {
                 return _.find(ageGroups, {value: item})
             })
         } else if (_.size(_.get(data, 'selectedGBGProduct.Categories', []))) {

             _.forEach(_.get(data, 'selectedGBGProduct.Categories', []), function (item) {
                 var foundTopLevelCategory = _.find(data.AllCategories, function (categoryRecord) {
                     return categoryRecord.TagName == item.Category
                 })
                 if (foundTopLevelCategory) {
                     if (item.Subcategory) {
                         var foundSubcategory = _.find(foundTopLevelCategory.subCategories, function (categoryRecord) {
                             return categoryRecord.TagName == item.Subcategory
                         })
                         if (foundSubcategory) {
                             ProductAgeRange = _.concat(ProductAgeRange, _.map(_.get(foundSubcategory, ['AgeGroups'], []), function (item) { /* use AgeGroups from selected GBG product categories */
                                 return _.find(ageGroups, {value: item})
                             }))
                         }

                     } else {
                         ProductAgeRange = _.concat(ProductAgeRange, _.map(_.get(foundTopLevelCategory, ['AgeGroups'], []), function (item) { /* use AgeGroups from selected GBG product categories */
                             return _.find(ageGroups, {value: item})
                         }))
                     }
                 }
             }.bind(this))
         } else {

             _.forEach(_.get(data, 'selectedCategories', []), function (selectedCategory) {
                 var categoryAgeRange = _.map(_.get(selectedCategory, ['AgeGroups'], []), function (item) { /* use AgeGroups from selected category or subcategory */
                     return _.find(ageGroups, {value: item})
                 })
                 ProductAgeRange = _.concat(ProductAgeRange, categoryAgeRange)
             })
         }
        ProductAgeRange = _.uniqBy(ProductAgeRange, 'value').filter(value => value !== undefined)
     return ProductAgeRange


 }
 export function displayProductSKUs() {
     var UpdatedProductSKU = _.get(this.state.screensData, 'currentServiceRecord.SellerID.SellerNumber', '') + '.' + _.get(this.state.screensData, 'currentServiceRecord.SellerPickupNumber', '') + '.' + _.get(this.state.screensData, 'nextProductNumber', '')
     if (_.get(this.state.screensData, 'currentServiceRecord.UpdatedProductSKUs',[]).length>0) {
         UpdatedProductSKU =this.state.screensData.currentServiceRecord.UpdatedProductSKUs[0]
         if (_.get(this.state.screensData.currentServiceRecord, 'UpdatedProductSKUs', []).length > 1) {
             var baseSKUMatch =UpdatedProductSKU.match(/^\d+\.\d+\.\d+$/)
             if(baseSKUMatch){
                 UpdatedProductSKU += ', ' + this.state.screensData.currentServiceRecord.UpdatedProductSKUs[1]
                 if (this.state.screensData.currentServiceRecord.UpdatedProductSKUs.length >2){
                     UpdatedProductSKU += ' - ' + _.last(this.state.screensData.currentServiceRecord.UpdatedProductSKUs)
                 }
             } else {
                 UpdatedProductSKU += ' - ' + _.last(this.state.screensData.currentServiceRecord.UpdatedProductSKUs)
             }
         }

     }

     return UpdatedProductSKU
 }
export function toggleCategoryExpandedState(params) {
    console.log('toggleCategoryExpandedState', params  );

    var itemIndex = _.findIndex(this.state.AllCategories, {'_id': params.categoryID});
    if (itemIndex !== -1) {
        this.setState({
            AllCategories: [...this.state.AllCategories.slice(0, itemIndex),
                {
                    ...this.state.AllCategories[itemIndex],
                    expanded: params.expanded
                },
                ...this.state.AllCategories.slice(itemIndex + 1)]
        })
    }

    return params.expanded;
}
export function selectCategory(params ) {
    var categoryIndex = _.findIndex(this.state.AllCategories, {'_id': params.categoryID});
    var subcategoryIndex = _.findIndex(this.state.AllCategories[categoryIndex].subCategories, {'_id': params.subCategoryID});
    var AllCategories = _.cloneDeep(this.state.AllCategories)

    if (categoryIndex !== -1 && (_.isUndefined(params.subCategoryID) || subcategoryIndex !== -1)) {
        var updatedCategory = {
            ...AllCategories[categoryIndex],
        }

        if (_.isUndefined(params.subCategoryID)) {
            updatedCategory.selected = params.selected;
            if (!_.isUndefined(params.expanded)){
                updatedCategory.expanded = params.expanded;
            }

        } else { /* it is a subcategory */
            updatedCategory.subCategories = [...AllCategories[categoryIndex].subCategories.slice(0, subcategoryIndex),
                {
                    ...AllCategories[categoryIndex].subCategories[subcategoryIndex],
                    selected: params.selected,
                },
                ...AllCategories[categoryIndex].subCategories.slice(subcategoryIndex + 1)]

        }

        return [...AllCategories.slice(0, categoryIndex),
            updatedCategory,
            ...AllCategories.slice(categoryIndex + 1)]
    }
}
export function renderSubCategories(category,selectCategoryCallback) {
    if (category.subCategories.length == 0) {
        return <div></div>;
    }
    return (
        <div className="left20 text-left">
            {category.subCategories.map((subcategory, rowID) => (
                <div
                    key={rowID}
                    onClick={() => {

                        selectCategoryCallback.call(self,{
                            deselectAllCategories: true,
                            'expanded': category.expanded,
                            // selected: _.isUndefined(subcategory.selected) ? true : (category.expanded && category.selected && subcategory.selected) ? true : !subcategory.selected,
                            selected: _.isUndefined(subcategory.selected) ? true :  !subcategory.selected,

                            categoryID: category._id,
                            subCategoryID: subcategory._id
                        })

                    } }
                   className="  top5 bot5    cursor-pointer">
                    <span
                      data-id={`subcategory-name-${subcategory.subcategory}`}
                      //  className={classNames( '', { subcategory.selected})}
                        style={{ 'color': subcategory.selected ? '#ef5085' : 'gray',


                    }}>{subcategory.CategoryName}</span>
                    {/*{subcategory.selected &&*/}
                    {/*<Image*/}
                    {/*source={Images.selected_checkbox}*/}
                    {/*resizeMode={'contain'}*/}
                    {/*style={ {   marginLeft:10, width:21, height:21} }/>*/}
                    {/*}*/}
                </div>
            ))
            }
        </div>)
}
export function renderTopLevelCategory( category,selectCategoryCallback, toggleCategoryExpandedState) {


    var self = this
    return (
        <div className="text-left  ">
            <span
                onClick={() => {
                     console.log('on top level render', category.expanded   );
                    selectCategoryCallback.call(self, {
                        'expanded':  true,
                        selected: !category.selected,
                        categoryID: category._id
                    })


                } }>
                <span data-id={`category-name-${category.CategoryName}`} className="cursor-pointer" style={{

                    'color': category.selected ? '#ef5085' : 'gray'
                }}>{category.CategoryName}</span>
            </span>
            <span
                style={{width: 37,  }}
                className="left20  cursor-pointer"
                onClick={() => {
                    toggleCategoryExpandedState.call(self, {
                        expanded:!category.expanded,
                        categoryID:category._id,
                    });

                } }>

                {category.subCategories.length > 0 &&
                    <span className="purple">
                        {category.expanded ?

                <FaMinusCircle  />:
                            <FaPlusCircle />}
                    </span>
                }

            </span>
        </div>
    );
}
export async function prepareAndValidateProductData(params={}){
     console.log('prepareAndValidateProductData', params);
     var self = this;
     var OriginalPrice =0
    if (_.get(self.state.screensData, 'selectedGBGProduct.OriginalProductData.RetailProductPrice')) {
        OriginalPrice = _.get(self.state.screensData, 'selectedGBGProduct.OriginalProductData.RetailProductPrice')
    } else if (_.get(self.state.screensData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice')) {
        OriginalPrice = _.get(self.state.screensData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice')
    }else if (_.get(self.state.screensData, 'selectedSearchAPIProduct.name') && _.get(self.state.screensData,'OriginalPrice')) {
        /* if RetailProductPrice or AmazonProductPrice is not available yet and user selected Amazon product, use its price*/
        OriginalPrice = formatNumbers.unformat(_.get(self.state.screensData,'OriginalPrice'))
    }
    var dataToSave = {
        Description: _.get(self.state.screensData, ['Description'], '').trim(),
        SellerID: _.get(self.state.screensData, [ 'SellerID'], ''),
        PickupID: _.get(self.state.screensData, ['PickupID'], ''),
        Condition: _.get(_.find(config.conditionsData, {number: this.state.screensData['Condition']}), 'tag', ''),
         SKU:   _.get(self.state.screensData, 'CurrentProductData.SellerID.SellerNumber', '') + '.' + _.get(self.state.screensData, 'CurrentProductData.PickupID.SellerPickupNumber', '') + '.' +  _.get(self.state.screensData.CurrentProductData, 'ProductNumber', ''),
        ProductNumber:  _.get(self.state.screensData.CurrentProductData, 'ProductNumber', ''),
        OriginalPrice: OriginalPrice,
        Price:0,
        ProductTags: [],
        CustomData: {
            ConditionValue: _.get(_.find(config.conditionsData, {number: this.state.screensData['Condition']}), 'value', '')
        },
         OriginalProductID : _.get(self.state.screensData, 'CurrentProductData.OriginalProductID'),
       serviceDataToUpdate:_.get(self.state.screensData, 'serviceDataToUpdate', {}), /* used when adding pre-listings*/
    }
    const {QualityCheckAnswers = []} = this.state.screensData;

    if(QualityCheckAnswers.length) {
        dataToSave.QualityCheckAnswers = QualityCheckAnswers;
    }

    if (_.get(this.state.screensData, ['ProductAgeRange'], []).length) {
        dataToSave['ProductAgeRange'] = _.map(_.get(this.state.screensData, ['ProductAgeRange'], []), function (item, key) {
            return item.value;
        });
    }
    if (self.state.currentFlow == 'PostingFlow' &&  _.get(this.state.screensData, ['productAction'], '') == 'AddPrelisting'){
        dataToSave['_id'] =_.get(self.state.screensData.CurrentProductData, 'ProductID' )
        if(self.state.screensData.CurrentProductData.GBGID){
            dataToSave.GBGID = self.state.screensData.CurrentProductData.GBGID
            if(self.state.screensData.CurrentProductData.ServiceItemMarket){
                dataToSave.ServiceItemMarket = self.state.screensData.CurrentProductData.ServiceItemMarket
            }
        }

    }else    if( self.state.currentFlow == '3PLProcessingFlow' ){
        dataToSave['_id'] =_.get(self.state.screensData, 'ProductID' )

        if(self.state.screensData.GBGID) {
            dataToSave.GBGID = self.state.screensData.GBGID;

            if(self.state.screensData.ServiceItemMarket) {
                dataToSave.ServiceItemMarket = self.state.screensData.ServiceItemMarket;
            }
        }


        if(self.state.screensData.inboundProductId && !self.state.screensData.nextProductNumber){
              let response = await this.props.makeRequest(
                  {
                    action: 'GetNextProductNumber',
                    PickupID: _.get(this.state.screensData, ['currentServiceRecord', '_id'], ''),
                  },{
                    type: 'post',
                    endpoint: '/process-action',
                    not_display_success_message: true,
                  }
                )
                console.log("=========================PRODUCT NUMBER ===========================================")
                console.log(response)
            self.state.screensData.nextProductNumber = response.data.ProductNumber
        }

        let productNumber = _.get(self.state.screensData, 'nextProductNumber')

        var SKU =_.get(self.state.screensData, 'currentServiceRecord.SellerID.SellerNumber', '') + '.' + _.get(self.state.screensData, 'currentServiceRecord.SellerPickupNumber', '') + '.' + `${productNumber}`

        _.extend(dataToSave, {
            SKU: SKU,
            TrackingNumbers: _.map(_.get(self.state.screensData, 'TrackingNumbers'), trackingNumberData=>{
               return {
                ...trackingNumberData,
                ProductItemSKU: SKU,
                TrackingNumberAddedAt: new Date()
               };
            }),
            ProductNumber: productNumber,
            SellerID: _.get(self.state.screensData, ['currentServiceRecord', 'SellerID', '_id'], ''),
            PickupID: _.get(self.state.screensData, ['currentServiceRecord', '_id'], ''),
        })
        const {RMAProductsData = {} } = this.state.screensData;

         if (RMAProductsData.sendRMAProductProcessedEvents) {
            let RMAProducts = RMAProductsData.RMAProductsToUse || []
            if(RMAProductsData.rmaProductNotFound){
                const {
                    _id: gbgProductId,
                    Brand,
                    Model
                } = self.state.screensData.selectedGBGProduct
                const hexGbgProducId = base64ToHex(gbgProductId, {convertToHEXUUID: true})
                RMAProducts = [{
                    "GBGProductID": hexGbgProducId,
                    "RMAProductBrand": Brand,
                    "RMAProductModel": Model,
                    "RMAProductID": "not_found",
                    "RMAVendorMetaData":{
                    },
                    "RMAProductStatus":"rma_created",
                    "GBGProductRecord":{

                    }
                 }]
            }

            Object.assign(dataToSave, {
                sendRMAProductProcessedEvents: RMAProductsData.sendRMAProductProcessedEvents,
                RMAProducts
            });
        }
    }
    dataToSave.SKUToPrint =dataToSave.SKU
    if(_.get(self.state.screensData, 'LocationInWarehouse')){
        dataToSave.LocationInWarehouse =_.get(self.state.screensData, 'LocationInWarehouse')
        dataToSave.SKU =dataToSave.SKU+'-'+_.get(self.state.screensData, 'LocationInWarehouse')
    }
    console.log('params.fieldsToInclude', params.fieldsToInclude  );
    _.extend(dataToSave,_.pick(this.state.screensData,_.get(params,'fieldsToInclude',[])))

    console.log('OriginalPrice', OriginalPrice  );
    if (dataToSave.Condition == _.find(config.conditionsData, {value: 'Loved'})['number']) {/* do not save HotBuy for Loved condition */
        dataToSave.HotBuy = false;
    }

    if(OriginalPrice){
    var calculateRecommendedPricesResponse = await calculateRecommendedPrices.call(this,_.extend( {
        OriginalPrice: dataToSave.OriginalPrice
    }), this.state.screensData)
    console.log('1 calculateRecommendedPricesResponse',   calculateRecommendedPricesResponse  );
    dataToSave.Price = formatNumbers.unformat(calculateRecommendedPricesResponse.recommendedPrice)
    dataToSave.recommendedPrice = dataToSave.Price //Adding this to send recommendedPrice to background
    dataToSave.recommendedPriceLog = calculateRecommendedPricesResponse.calculateRecommendedPriceData
    }
    //  console.log(' this.recommendedPriceAmount ', this.recommendedPriceAmount);
    if(_.get(self.state.screensData, ['selectedGBGProduct', '_id'])){
        _.extend(dataToSave, {
            GBGProductID: _.get(self.state.screensData, ['selectedGBGProduct', '_id']),
            Brand: _.get(self.state.screensData, ['selectedGBGProduct', 'Brand']),
            Model: _.get(self.state.screensData, ['selectedGBGProduct', 'Model'])
        })
        dataToSave.ProductName = (dataToSave.Brand == 'Unknown' ? '' : dataToSave.Brand + ' ') + dataToSave.Model
        if (dataToSave.Brand !== 'Unknown') {
            dataToSave['ProductTags'].push('Brand_' + dataToSave.Brand)
        }
        if (dataToSave.Model) {
            dataToSave['ProductTags'].push('Model_' + dataToSave.Model)
        }
    }
    var Weight = `${_.get(self.state.screensData, 'selectedGBGProduct.OriginalProductData.Weight', '') || ""}`;
    var Shippable = _.get(self.state.screensData, 'Shippable', false);

     if ((Weight == '' || isNaN(parseFloat(Weight)) || parseFloat(Weight) == 0)) {

    } else {
        dataToSave['Weight'] = Weight;
    }
    if (_.size(_.get(self.state.screensData, ['ProductCategories'], [])) > 0) {
        dataToSave['Categories'] = _.get(self.state.screensData, ['ProductCategories'], [])
    }
    var donationProduct =_.find(_.get(dataToSave, ['Categories'], []), item => {
        return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory)
    })
    console.log('donationProduct', donationProduct  );
    if(donationProduct){
        console.log('dataToSave', dataToSave.Price  );
        _.extend(dataToSave, { Price: 0 })

        console.log('dataToSave 1', dataToSave.Price  );
    }

   /// if (_.includes(fieldsToInclude,'OriginalImagesToUpload')){
        dataToSave['OriginalImagesToUpload'] = _.map(this.state.screensData.images, function (localImage, key) {
            return {
                s3FileURL: localImage.s3FileURL,
                Position: key + 1,
                Type: _.get(localImage, 'type', 'User'),
                CustomImageData: _.get(localImage, 'CustomImageData'),
                ImageIDToSave: _.get(localImage, ['imageID'], undefined), /* _id is set later */
                URL: localImage.s3FileURL ? localImage.s3FileURL : localImage.fullUri
            }
        })

    prepareProductTags.call(this, dataToSave)
    if(dataToSave.Weight) {
        prepareDataForWeight.call(this, dataToSave)
    }

    if(params.addProcessingFee) {
        if (_.includes(['openbox_used', 'refurbish_parts', 'salvage', 'new_condition'], _.get(self.state.screensData, 'TrackingNumbers.0.Disposition'))) {
            const {TrackingNumbers: trackingNumbers = [{}]} = dataToSave;
            dataToSave['FeesToAdd'] =_.concat(_.get(dataToSave,'FeesToAdd',[]), [{
                doNotSaveInProduct:true,
                amount: _.get(self.state.screensData, 'TrackingNumbers.0.Disposition') == 'salvage' ? _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.DisposeCost', 0) : _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.ProcessCost', 0),
                Description: _.get(self.state.screensData, 'TrackingNumbers.0.Disposition') == 'salvage' ? 'Disposal Fee' : 'Processing Fee',
                CustomData: {
                    GBGID: trackingNumbers[0].GBGID,
                    ProductItemSKU:trackingNumbers[0].ProductItemSKU,
                    TrackingNumber: trackingNumbers[0].TrackingNumber,
                    Disposition: trackingNumbers[0].Disposition,
                }
            }])
        }
    }

    if( self.state.currentFlow == '3PLProcessingFlow' && !self.FeatureFlags.DeterministicCondition) {
        if (_.size(_.get(self.state.screensData, 'QualityCheckInstructions', [])) == 1 && _.get(self.state.screensData, 'QualityCheckInstructions.0.Action') == 'DONATE') {
            dataToSave.FeesToAdd =[{
                amount:  _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.DisposeCost', 0),
                Description: 'Disposal Fee',
                CustomData: {TransactionNotes: 'Donation'}
            }]
        }
    }

    /// Adding inbound product to data to save
    if(self.state.screensData.inboundProductId){
        dataToSave.InboundProductID = self.state.screensData.inboundProductId
    }


    return dataToSave
}

function prepareRMAProductData(dataToSave) {
    const {RMAProductsData = {} } = this.state.screensData;

    if (RMAProductsData.sendRMAProductProcessedEvents) {
        Object.assign(dataToSave,{
            sendRMAProductProcessedEvents:RMAProductsData.sendRMAProductProcessedEvents,
            RMAProducts:RMAProductsData.RMAProductsToUse
        });
        //   if (RMAProductsData.RMAProductsToUse.length) {
        //     const {Disposition} = dataToSave.TrackingNumbers[0];
        //     dataToSave.TrackingNumbers[0].ProductItemStatus = Disposition == 'salvage' ? 'DISPOSED' : 'PROCESSED';
        //     dataToSave.TrackingNumbers[0].RMAProductID = matchingRMAProducts[0].RMAProductID;
        // } else {
        //     dataToSave.TrackingNumbers[0].ProductItemStatus = 'ADDITIONAL_ITEM';
        // }
    }
}
 function displayBackButton(params) {
     if (!_.isUndefined(params.notDisplayPrevButton)) {
         return false
     }
     var currentScreenIndex = _.findIndex(this.state.screensStack, item => {
         return item == this.state.currentScreen
     })
     if (currentScreenIndex <1){
         return  false
     }
     if (_.size(this.state.screensStack) > 1) {
         return true
     } else {
         return false
     }
 }
 export function displayPrevNextButtons(params = {}) {
      var currentScreenIndex = _.findIndex(this.state.screensStack, item => {
         return item == this.state.currentScreen
     })
     return <div className={  classNames('arrows-outer-wrapper',
         {
             '--smaller-screen':_.get(params,'paginationBox',false),
         })}   >
         {(currentScreenIndex >0 && displayBackButton.call(this,params)) &&
         <div className={  classNames('arrow-wrapper --left',
             {
                 // '--larger-screen':!_.get(params,'pagination-box',true),
                 '--smaller-screen':_.get(params,'paginationBox',false),
               //  '--disabled-arrow': false,
             })} onClick={() => {
               var screenStackToUpdate = [...this.state.screensStack]

             this.setState({
                 screensStack: screenStackToUpdate,
                 currentScreen: this.state.screensStack[currentScreenIndex - 1]
             }, ()=>{
                    params.goToPreviousScreenCallback && params.goToPreviousScreenCallback();
             } )
         }}
         >
             <i className={  classNames('arrow --left', {     '--smaller-screen':_.get(params,'paginationBox',false)
                // ,'--disabled-arrow': true
             })}></i>
         </div>
         }


         {!((this.state.currentScreen == SCREENS.barcode_printing_screen.key && this.state.currentFlow == '3PLProcessingFlow') ||(this.state.currentScreen == SCREENS.confirmation_screen.key && this.state.currentFlow == 'PostingFlow') ) &&
         <div className={  classNames('arrow-wrapper --right',
             {
                 '--smaller-screen':_.get(params,'paginationBox',false),
                   '--disabled-arrow': this.state.screensStack.length <= (currentScreenIndex + 1)
             })}
              onClick={() => {

            if(this.state.screensStack.length > (currentScreenIndex + 1)) {
                this.setState({
                    currentScreen: this.state.screensStack[currentScreenIndex + 1]
                })
            }

         }}>
             <i className={  classNames('arrow --right', {     '--smaller-screen':_.get(params,'paginationBox',false)
                // ,'--disabled-arrow': true
             })}></i>
         </div>
         }

     </div>
 }
export function prepareDataForScreen() {
    var screenName = this.state.currentScreen,self = this;
    var dataToSave = {};
    console.log('screenName', screenName  );
    switch(screenName) {

        case SCREENS.quality_checks_screen.key:
            if(!self.FeatureFlags.DeterministicCondition) {
                var QualityCheckInstructions = [];

                if (_.get(this.state.screensData, 'qualityCheckQueryParams.MatchingType.0') !== 'GBGProductNotFound') {
                    _.forEach(this.state.screensData.qualityCheckItems, item => {
                        if (item.checkedStatus == 'failed') {
                            _.forEach(_.filter(_.get(item, 'Rules', _.get(item, 'QualityCheckRules', [])), { /* QualityCheckRules are added along with custom Quality checks on GBG Product edit page */
                                Type: 'Unchecked',
                            }), function (uncheckedRule) {
                                if (_.isUndefined(uncheckedRule.Field)) {
                                    QualityCheckInstructions.push({Action: uncheckedRule.Action});
                                } else if (uncheckedRule.Field == 'Price' && _.get(self.state.screensData, 'recommendedPriceAmount', 'n/a') !== 'n/a') {
                                    if (config.operatorsMap[uncheckedRule.Operator](_.get(self.state.screensData, 'recommendedPriceAmount', 'n/a'), uncheckedRule.Value)) {
                                        QualityCheckInstructions.push({Action: uncheckedRule.Action});
                                    }
                                }
                            });
                        }
                    });
                }



                if (_.size(QualityCheckInstructions)) {
                    var foundRecalledInstruction = _.find(QualityCheckInstructions, item => {
                        return item.Action.toLowerCase() == 'recalled';
                    });
                    var foundDonateInstruction = _.find(QualityCheckInstructions, item => {
                        return item.Action.toLowerCase() == 'donate';
                    });
                    var foundTroubleshootingRoomInstruction = _.find(QualityCheckInstructions, item => {
                        return item.Action.toLowerCase() == 'troubleshooting room';
                    });


                    if (foundRecalledInstruction) {
                        dataToSave.QualityCheckInstructions = [{'Action': 'RECALLED'}];
                    } else if (foundDonateInstruction) {
                        dataToSave.QualityCheckInstructions = [{'Action': 'DONATE'}];
                    } else if (foundTroubleshootingRoomInstruction) {
                        dataToSave.QualityCheckInstructions = [{'Action': 'TROUBLESHOOTING ROOM'}];

                        if ('PartnerPurchased' !== _.get(self.state.screensData, 'CurrentProductData.SellerID.InventoryOwnership')) { /* if item is not GBG Inventory  I, use Donate instruction */
                            dataToSave.QualityCheckInstructions = [{'Action': 'DONATE'}];
                        }
                    }
                } else {
                    dataToSave.QualityCheckInstructions = [];
                }
            } else {
                dataToSave.QualityCheckAnswers = [];
                 this.state.screensData.qualityCheckItems.forEach(item => {
                     const {selectedAnswer = {}, selectedChoices = []} = item;
                     let qualityCheckAnswer = {};

                     if(selectedChoices.length > 0) {
                        qualityCheckAnswer.Choices = selectedChoices;
                    }

                    if(selectedAnswer.Penalty) {
                        qualityCheckAnswer.Penalty = selectedAnswer.Penalty;
                    }

                     if(selectedAnswer.AnswerText) {
                         qualityCheckAnswer.AnswerText = selectedAnswer.AnswerText;
                     }

                     if(!_.isEmpty(qualityCheckAnswer)) {
                         if(!item.customQualityCheck) {
                             qualityCheckAnswer.QualityCheckID = base64ToHex(item._id);
                         }
                         qualityCheckAnswer.Prompt = item.Text;
                         dataToSave.QualityCheckAnswers.push(qualityCheckAnswer);
                     }
                });
                 const currentCondition = config.conditionsData.find(item=>item.number == this.state.screensData.Condition);

                if(!currentCondition) {
                    return self.props.displayMessage({
                        'messageType': 'warning',
                        'messageCode': `Sorry, condition is not available for ${this.state.screensData.Condition}`
                    });
                }

                 const {TrackingNumbers = []} = this.state.screensData;

                if(TrackingNumbers.length) {
                    dataToSave.TrackingNumbers = [{
                        ...this.state.screensData.TrackingNumbers[0],
                        Disposition: currentCondition.disposition
                    }];
                }
            }
            break;
    }
    return  dataToSave
}
 export function sentenceCase(input, lowercaseBefore) {
     input = ( input === undefined || input === null ) ? '' : input;
     if (lowercaseBefore) { input = input.toLowerCase(); }
     return input.toString().replace( /(^|\. *)([a-z])/g, function(match, separator, char) {
         return separator + char.toUpperCase();
     });
 }
 export async function prepareDataForNextScreen(params) {
      var dataToSave ={}, self=this
console.log('prepareDataForNextScreen', params  );

     switch(params.screenName) {

         case SCREENS.confirmation_screen.key:
              if(config.getEnvironmentName() == 'local'  || params.nextScreenIndex ==-1)  {
                 var GBGProductTagsToAssign = [], allGBGProductTagsToAssign = [],Weight = ''
                  if (_.get(this.state.screensData, ['productAction'], '') == 'EditListing') {
                      Weight = `${_.get(this.state.screensData, ['CurrentProductData', 'ProductVariants', '0', 'OriginalProductData', 'Weight'], '') || ""}`
                  } else if (_.includes(['PostPrelisting', 'AddPrelisting'], _.get(this.state.screensData, ['productAction'], ''))) {
                      Weight = `${_.get(this.state.screensData, 'selectedGBGProduct.OriginalProductData.Weight', '') || ""}`
                  }

                  var GBGProductBoxSizeTag  =  _.find(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), function (tag) {
                      return _.includes(tag, 'Box_')
                  })
                  var OriginalProductDimensions = prepareProductDimensionsData.call(this)

                  var calculatedBoxSize = getMinimumBoxSize.call(this,OriginalProductDimensions)
                 if (_.size(_.get(this.props.appData, ['GBGProductTags', 'GBGProductTagsList'], []))) {
                     allGBGProductTagsToAssign = _.filter(_.get(this.props.appData, ['GBGProductTags', 'GBGProductTagsList'], []), item => {
                         return item.note !== 'doNotSave'
                             //&& _.get(item, 'conditions', []).length == 0
                     })
                     GBGProductTagsToAssign = _.map(_.intersection(_.get(this.state.screensData, 'selectedGBGProduct.GBGProductTags', []), _.map(allGBGProductTagsToAssign, 'value')), tag => {
                         var tagToAssign = _.find(allGBGProductTagsToAssign, {value: tag})
                         return tagToAssign
                     })
                     console.log('GBGProductTagsToAssign', GBGProductTagsToAssign);
                 }
                 dataToSave = {
                     GBGProductTagsToAssign: GBGProductTagsToAssign,
                     allGBGProductTagsToAssign: allGBGProductTagsToAssign,
                     OriginalProductDimensions: OriginalProductDimensions,
                     boxSizeConfirmed: GBGProductBoxSizeTag &&  _.get(this.state.screensData, 'selectedGBGProduct.OriginalProductData.OriginalProductCustomData.BoxSizeConfirmed') ? true : false,
                     dimensionsModalVisible: false,
                     calculatedBoxSize:calculatedBoxSize,
                     Weight: Weight,
                 }
             }
console.log('in confirmation', _.get(self.state.screensData, 'productCustomData.currentProductAction') );
             if('priceCheckPrelisting' !== _.get(self.state.screensData, 'productCustomData.currentProductAction') && config.getEnvironmentName() !== 'local1') {
                 var productData = await prepareAndValidateProductData.call(this, {})

                 dataToSave.SKUToPrint = productData.SKUToPrint
                 dataToSave.ProductPriceToSave = productData.Price

                 if ( (self.state.currentFlow == '3PLProcessingFlow' && !_.get(self.state.screensData, 'CurrentPartnerProductData._id', '') || 'AddPrelisting' == _.get(this.state.screensData, ['productAction'], '')) &&  _.get(productData, 'Price',0) ==0) {/* OriginalPrice is empty when Amazon product not found or not selected. PostedPrice can be set based on similar products*/
                     console.log('Posted price not set in confirmation'   );

                     /*create Price Check pre-listing*/

                     if (_.get(self.state.screensData, ['selectedGBGProduct', '_id']) &&
                         !_.find(_.get(self.state.screensData, ['ProductCategories'], []), item => {
                             return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory)})){
                         dataToSave.productCustomData =   _.extend({}, _.get(self.state.screensData, 'productCustomData', {}), {currentProductAction: 'priceCheckPrelisting'})

                     }
                 }
             }
             console.log('prepareDataForNextScreen dataToSave',   dataToSave  );
             break
         case SCREENS.fees_screen.key:
             if(config.getEnvironmentName() == 'local'  || params.nextScreenIndex ==-1)  {
                 var stateDataToUpdate = {}
                 dataToSave = {
                     HotBuy: _.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'hotBuy'),
                     Shippable: config.getEnvironmentName() == 'local' ? false : 'not_specified'
                 }

                 if (this.state.currentFlow == 'PostingFlow') {

                     if (_.get(this.state.screensData, ['CurrentProductData', '_id'], false)) {/* this is finalizing a pre-listing or create a listing based on original product*/
                         var productData = this.state.screensData.CurrentProductData
                         console.log('prepareStateDataForExistingProduct');
                         _.forEach(_.get(productData, ['ProductTags'], []), function (tag) {
                             if (_.includes(tag, 'Shipping Options_Shippable')) {
                                 stateDataToUpdate.Shippable = true
                                 return true
                             }
                         });
                         if (_.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'Shipping Options_Shippable')) {

                             if (_.get(this.state.screensData, ['productAction'], '') == 'EditListing') {
                                 if (stateDataToUpdate.Shippable.toString() == 'false') {
                                     stateDataToUpdate.OverrideShippable = true  /* it was overriden earlier */
                                 }
                             } else {
                                 stateDataToUpdate.Shippable = true;
                             }

                         } else if (_.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'Shipping Options_Notshippable')) {
                             if (_.get(this.state.screensData, ['productAction'], '') == 'EditListing') {
                                 if (stateDataToUpdate.Shippable.toString() == 'true') {
                                     stateDataToUpdate.OverrideShippable = true /* it was overriden earlier */
                                 }
                             } else {
                                 stateDataToUpdate.Shippable = false;
                             }
                         }
                         console.log(' stateDataToUpdate.Shippable', stateDataToUpdate.Shippable);
                         if (_.size(_.get(productData, ['CustomData', 'FeesToAdd'], []))) {
                             stateDataToUpdate.FeesToAdd = _.get(productData, ['CustomData', 'FeesToAdd'], [])
                             stateDataToUpdate.displayFeeList = true
                         }
                         stateDataToUpdate.LocationInWarehouse = _.get(productData, ['LocationInWarehouse'], '')

                         if (_.get(this.state.screensData, ['productAction'], '') == 'EditListing') {
                             stateDataToUpdate.HotBuy = false;
                             _.forEach(_.get(productData, ['ProductTags'], []), function (tag) {
                                 if (tag == 'hotBuy') {
                                     stateDataToUpdate.HotBuy = true
                                     return true
                                 }
                             });
                         }

                     } else {
                         if (_.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'Shipping Options_Shippable')) {
                             dataToSave.Shippable = true;
                         } else if (_.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'Shipping Options_Notshippable')) {
                             dataToSave.Shippable = false
                         }

                     }
                     _.extend(dataToSave, stateDataToUpdate)
                 } else {
                     if (_.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'Shipping Options_Shippable')) {
                         dataToSave.Shippable = true;
                     } else if (_.includes(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), 'Shipping Options_Notshippable')) {
                         dataToSave.Shippable = false
                     }
                 }
                 if(config.getEnvironmentName() !== 'local1') {
                     var productData = await prepareAndValidateProductData.call(this, {})
                     dataToSave.SKUToPrint = productData.SKUToPrint
                     dataToSave.ProductPriceToSave = productData.Price

                     if ( (self.state.currentFlow == '3PLProcessingFlow' && !_.get(self.state.screensData, 'CurrentPartnerProductData._id', '') || 'AddPrelisting' == _.get(this.state.screensData, ['productAction'], '')) &&  _.get(productData, 'Price',0) ==0) {/* OriginalPrice is empty when Amazon product not found or not selected. PostedPrice can be set based on similar products*/
                         console.log('Posted price not set Fees selection'   );

                         /*create Price Check pre-listing*/

                         if (_.get(self.state.screensData, ['selectedGBGProduct', '_id']) &&
                             !_.find(_.get(self.state.screensData, ['ProductCategories'], []), item => {
                                 return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory)})){
                             dataToSave.productCustomData =   _.extend({}, _.get(self.state.screensData, 'productCustomData', {}), {currentProductAction: 'priceCheckPrelisting'})

                         }
                     }
                 }
             }
                 console.log('fee screen data', dataToSave  );
              break

         case SCREENS.pallet_dispute_screen.key:
             console.log('pallet_dispute_screen'  );


             dataToSave.ReceivedQuantity =  _.get(this.state.screensData, 'CurrentProductData.PalletProductData.Quantity', _.get(this.state.screensData, 'CurrentProductData.ProductVariants.0.Quantity', 1)).toString(),
             dataToSave.PalletProductNotes =_.get(this.state.screensData, 'CurrentProductData.PalletProductData.PalletProductNotes', ''),
             console.log('barcode_printing_screen', dataToSave  );
            break
         case SCREENS.gbg_product_details_screen.key:
             const {UPCCodeRecord= {}} = self.state.screensData.selectedGBGProduct;
             const {VariationLinks=[]}  = UPCCodeRecord;
             if(VariationLinks.length) {
                dataToSave.modelVariations = getModelVariationsForUPCCode(self.state.screensData.selectedGBGProduct, UPCCodeRecord)
             }
             dataToSave.sortVariationOptions = 'asc'
            break
     }
     //dataToSave.QualityCheckInstructions = [{'Action': 'TROUBLESHOOTING ROOM'}]
      return  dataToSave
 }

export function updatePalletProduct() {
     var self = this;
     this.setState({
         pending: true
     })

var displayPostingProductPrompt = false;
     var dataToSave = {PalletProductData: { PalletProductStatus:'Checked'}}
     if (this.state.screensData.ReasonCode) {
         dataToSave.PalletProductData.ReasonCode = this.state.screensData.ReasonCode
         if(_.includes(['GrosslyMisinterpreted','DifferentQuantityReceived','ItemDamagedInShipping'],this.state.screensData.ReasonCode)){
             displayPostingProductPrompt = true
         }
     }
     console.log('displayPostingProductPrompt', displayPostingProductPrompt  );
     if (this.state.screensData.PalletProductNotes) {
         dataToSave.PalletProductData.PalletProductUpdatedNotes = this.state.screensData.PalletProductNotes
     }
     if (isNaN(this.state.screensData.ReceivedQuantity)) {
         this.setState({
             pending: false
         })
         return self.props.displayMessage({
             'messageType': 'warning',
             'messageCode': 'Please, specify valid quantity'
         });
     }

     if (this.state.screensData.ReceivedQuantity) {
         var COGsForAllOriginalProducts = _.get(this.state.screensData.CurrentProductData, 'PalletProductData.WhatWePaidToUnit',0) * _.get(this.state.screensData.CurrentProductData, 'PalletProductData.Quantity',0)
         if (COGsForAllOriginalProducts == 0) {
             self.setState({pending: false});
             return self.props.displayMessage({
                 'messageType': 'warning',
                 'messageCode': 'Can not calculate updated COGs value'
             });
         }
         var COGSToUpdate= formatNumbers.toFixed(COGsForAllOriginalProducts /  this.state.screensData.ReceivedQuantity, 2)
         console.log('COGSToUpdate', COGSToUpdate  );
         dataToSave.COGS =COGSToUpdate
         // dataToSave.PalletProductData.UpdatedQuantity = this.state.ReceivedQuantity
         dataToSave.Quantity = parseInt(this.state.screensData.ReceivedQuantity)
         if (dataToSave.Quantity !== _.get(this.state.screensData.CurrentPartnerProductData,'ProductItems',[]).length){
             var SKU =_.get(this.state.screensData, ['CurrentProductData', 'SellerID', 'SellerNumber'], '') + '.' + _.get(this.state.screensData, ['CurrentProductData', 'PickupID', 'SellerPickupNumber'], '') + '.' + _.get(this.state.screensData, ['CurrentProductData', 'ProductNumber'], '')
             dataToSave.ProductItemsToUpdate = []
             dataToSave.LocationInWarehouse = 'Multiple'
             dataToSave.SKU  =SKU+ '-Multiple'
             _.forEach(_.range(0,dataToSave.Quantity), index=>{
                 dataToSave.ProductItemsToUpdate.push({
                     ProductItemSKU:SKU+(index ==0?'':'.' +index),
                 })
             })
         }
     }


     // _.forEach(_.get(self.state.screensData, ['imagesToDelete'], []), function (imageID, key) {
     //     functionsToCall.push(function (done) {
     //         console.log('imageID delete image', imageID);
     //         self.props.makeRequest({}, {
     //             'endpoint': '/products/' + encodeURIComponent(_.get(self.state.screensData, ['CurrentProductData', '_id'], 'n/a')) + '/images/' + encodeURIComponent(imageID),
     //             'not_display_success_message': true,
     //             type: 'delete',
     //         }).then(function () {
     //             done(null, true)
     //         }).catch(function (error) {
     //             console.log('error', error);
     //             done(null, error)
     //         })
     //     })
     // })
    dataToSave['OriginalImagesToUpload'] = _.map(_.get(this.state.screensData,'palletImages',[]), function (localImage, key) {
        return {
            s3FileURL: localImage.URL,
            Position: key + 1,
            DoNotSaveImageInShopify: true,
            Type: 'User',
            CustomImageData: {Note:'Pallet image'},
             URL:localImage.URL
        }
    })
             return self.props.makeRequest(dataToSave,
                 {
                     "type": 'patch',
                     "endpoint": "/products/" + encodeURIComponent(this.state.screensData.CurrentProductData._id),
                     //    'messageCode': "Pallet product data updated",
                 }).then(function (response) {

                 self.props.displayMessage({
                     'messageType': 'success',
                     'messageCode': 'Pallet product data updated'
                 });
                 if (displayPostingProductPrompt) {
                     self.resetScreensData({fieldsToKeep:['BarcodeNumber'], nextScreen:SCREENS.posting_pallet_product_screen.key})
                 }else{
                     self.resetScreensData()
                 }
                 return true;
             }).catch(function (error) {
                 console.log('error', error  );
                 self.setState({
                     pending: false
                 })
                 return false
             })

 }
 function getMinimumBoxSize(productDimensions) {

     if (_.some(['Height', 'Width', 'Length'], (key) => {
             return _.isUndefined(productDimensions[key])
         })){
         return false
     }

     var matchingBoxes = []
     var productDimensionValues = _.map(productDimensions, item => {
         return parseFloat(item)
     }).sort(function (a, b) {
         return a - b;
     });
     _.forEach(this.props.appData.boxSizeData.boxSizeList, function (boxSize) {

         var boxDimensions =  _.clone(boxSize.dimensions).sort(function (a, b) { /* sort in asc order and clone to not mutate array in the reducer*/
             return a - b;
         });
          // console.log('boxSize.dimensions 2', boxSize.dimensions   );


         if ((productDimensionValues[0] <= boxDimensions[0]) && (productDimensionValues[1] <= boxDimensions[1]) && (productDimensionValues[2] <= boxDimensions[2])) {
             matchingBoxes.push({
                 boxData: boxSize,
                 originalDimensions:boxSize.dimensions,
                 boxVolume: boxDimensions[0] * boxDimensions[1] * boxDimensions[2],
             })
         } else {
         }
     })
     console.log('matchingBoxes ', matchingBoxes   );
     if (!_.size(matchingBoxes)) {
         return false
     }
     matchingBoxes = _.orderBy(matchingBoxes, 'boxVolume', 'asc')
     console.log('matchingBoxes', matchingBoxes  );
     return  {
         Length:_.get(matchingBoxes[0], 'originalDimensions.0'),
         Width:_.get(matchingBoxes[0], 'originalDimensions.1'),
         Height:_.get(matchingBoxes[0], 'originalDimensions.2'),

     }


 }
  export function fetchBoxSizeSettings( ) {

     var self = this;
     var methodData = {
         "endpoint": "/settings",
         timeout:27000,
         'not_display_error_message': true,
     }
     this.props.makeRequest({include:['updatedAt'], Name: 'BoxSettings'}, methodData).then(function (res) {

         if (_.isUndefined(_.get(self.props.appData, 'boxSizeData.updatedAt')) || (!moment(_.get(res.data.data, '0.updatedAt')).isSame(moment(self.props.commonDataReducer.boxSizeData.updatedAt)))) {
             self.props.makeRequest({ Name: 'BoxSettings'},methodData).then(function (res) {

                 if(_.get(res.data.data, '0._id')) {
                     return  self.props.dispatchAction({
                         'boxSizeData': {
                             updatedAt: _.get(res.data.data, '0.updatedAt',),
                             boxSizeList: _.get(res.data.data, '0.Data.Rules', []),
                         },
                     }, UPDATE_APP_DATA)
                 }
             })
         }
     }).catch(err => {
     });
 }
 function  prepareProductDimensionsData() {
     var productDimensions = {}
      if (_.get(this.state.screensData, ['selectedSearchAPIProduct', 'AmazonProduct'], false)) {/* user selected Amazon product on Options screen */
         _.forEach(['Height', 'Width', 'Length'], (key) => {
             if (_.get(this.state.screensData.selectedSearchAPIProduct, key)) {
                 if (_.includes(['inches', 'Inches', 'Centimeters', 'hundredths-inches', 'Hundredths Inches'], _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']))) {
                     productDimensions[key] = _.get(this.state.screensData.selectedSearchAPIProduct, key)

                     if (_.includes(['hundredths-inches', 'Hundredths Inches'], _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']))) {
                         productDimensions[key] = productDimensions[key] / 100;
                     } else if (_.includes(['Centimeters'], _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']))) {
                         productDimensions[key] = productDimensions[key] / 2.54;
                         /* convert to inches to correctly display them */
                     }
                 } else {
                     this.props.displayMessage({
                         messageType:'warning',
                         'messageCode':  'New ' + key + ' unit ' + _.get(this.state.screensData.selectedSearchAPIProduct, [key + 'Unit']) + ' returned from Amazon API',
                     });

                 }
             }
         })

     } else {
         _.forEach(['Height', 'Width', 'Length'], (key) => {

             if (_.get(this.state.screensData, ['productAction'], '') == 'EditListing' && _.get(this.state.screensData, ['CurrentProductData', 'ProductVariants', '0', 'OriginalProductData', key])) {
                 var fieldValue = _.get(this.state.screensData, ['CurrentProductData', 'ProductVariants', '0', 'OriginalProductData', key])
                 productDimensions[key] = fieldValue
             } else   if (_.get(this.state.screensData, ['selectedGBGProduct', 'OriginalProductData', key])) {
                 var fieldValue = _.get(this.state.screensData, ['selectedGBGProduct', 'OriginalProductData', key])
                 var fieldValueUnit = _.get(this.state.screensData, ['selectedGBGProduct', 'OriginalProductData', [key + 'Unit']])
                 if (_.includes(['hundredths-inches', 'Hundredths Inches'], fieldValueUnit)) {
                     fieldValue = fieldValue / 100;
                 } else if (_.includes(['Centimeters'], fieldValueUnit)) {
                     fieldValue = fieldValue / 2.54;
                     /* convert to inches only for displaying them. In the database raw dimensions data is stored, except Weight that is converted to lb*/
                 }
                 productDimensions[key] = fieldValue
             }
         })
     }
     console.log('Amazon product or  OriginalProductData dimensions', productDimensions);

     return productDimensions;
 }
export function displayTimeTrackingButtons(params){
    if (!(_.get(this.props, ['userReducer','contractor', '_id'], false) && _.get(this.props, ['userReducer','contractor', 'Status']) =='Active')){
        return null
    }
    var self = this

    var activitiesList =_.chunk(_.filter(config.timeTrackingActivityData,item=>{
    //    console.log('item.allowedAccessRights', item.allowedAccessRights  );
        if (config.checkAccessRights.call(self,{ resources:item.allowedAccessRights}) ){
            return true
        }
        if (_.size(_.intersection(_.get( this.props.userReducer.user, [ 'ResourceAccessRights'], []), ['full_access'])) > 0   ){
            return true
        }
    }),2)
   // console.log('ResourceAccessRights', _.get(this.props.userReducer.user, 'ResourceAccessRights',[])  );


    return   <div>
        {(_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false) && _.get(params,'changeActivityAllowed',true)) ?
        <Button
            className="btn btn-lg custom-btn   --pink"
            style={{width: 180, marginRight: 40}}

            onClick={() => {
                var self = this;
                this.setState({activitiesListModalVisible: false}, ()=> {
                    this.setState({activitiesListModalVisible: true})
                })

            }}

        >
            <span  >Change Activity</span>
        </Button> :
        <Button
            className="btn btn-lg custom-btn --pink"
            style={{width: 100, marginRight: 40}}
            disabled={this.state.pending || _.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false) !== false}
            onClick={() => {
                this.setState({activitiesListModalVisible: false}, ()=> {
                    this.setState({activitiesListModalVisible: true})
                })

            }}
        >
            <span  >Start</span>
        </Button>}
        <Button
            className="btn btn-lg custom-btn   --pink"
            style={{width: 100}}
            disabled={this.state.pending || !_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)}
            onClick={() => {
                var self = this;
                this.setState({pending: true}, function () {
                    saveTimeTrackingLog.call(self, {

                        type: 'stoppedByUser'
                    }).then(() => {
                        resetTrackedTime.call(self)
                        self.setState({pending: false})

                        console.log('stopped');
                    }).catch(e => {
                        self.setState({pending: false})
                        console.log('error 2', e);

                    })

                })

            }}

        >
            <span  >Stop</span>
        </Button>
        <Modal className=" " show={this.state.activitiesListModalVisible}
               onHide={() => this.setState({
                   activitiesListModalVisible: false
               })}>
            <Modal.Header closeButton>
                <Modal.Title className="text-center">    {'What is your activity?'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {_.map(activitiesList,(items,outerIndex)=>{
                    return <div  key={outerIndex} className="flex-box" style={{
                        flexDirection: 'row', marginTop: 20, justifyContent:items.length ==1? 'center':'space-around'
                    }}>
                        <Button
                            className="btn btn-primary  "
                            style={{width: 180 }}

                            onClick={() => {
                                //    var secondsTillExpectedWorkingTimeEndAt= moment(_.get(self.props.User, [ 'customUserData','expectedWorkingTimeEndAt'])).diff(moment(), 'seconds')
                                //   console.log('secondsTillExpectedWorkingTimeEndAt', secondsTillExpectedWorkingTimeEndAt  );
                                if(_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)){
                                    stopAndStartTimeTracking.call(self, {activityType:_.get(items,'0.name','')}).catch(e => {

                                        console.log('error 3', e);

                                    })

                                    console.log('change activity'   );


                                }else {
                                    console.log('start timer'   );
                                    startTimeTrackingByUser.call(this,_.extend(params,{
                                        activityType: _.get(items,'0.name','')
                                    }))
                                    this.setState({
                                        activitiesListModalVisible: false,
                                        activityExpectedTimeModalVisible: true,
                                    })

                                }

                            }}>
                           <span>{_.get(items,'0.comment','')}</span>
                        </Button>
                        {_.get(items, '1.comment', '') !== '' &&
                        <Button
                            className="btn btn-primary  "
                            style={{width: 180 }}

                            onClick={() => {
                                    if (_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)) {
                                        stopAndStartTimeTracking.call(self, {activityType:_.get(items,'1.name','')}).catch(e => {

                                            console.log('error 4', e);

                                        })
                                    } else {
                                        startTimeTrackingByUser.call(this,_.extend(params,{
                                            activityType: _.get(items,'1.name','')
                                        }))
                                        this.setState({
                                            activitiesListModalVisible: false,
                                            activityExpectedTimeModalVisible: true,
                                         })

                                    }


                                }}>
                            <span>{_.get(items,'1.comment','')}</span>
                        </Button>
                        }

                    </div>

                })}
            </Modal.Body>
            <Modal.Footer>
                <Row className="left0">
                    <Col md={12} sm={12} xs={12} className="pright0">
                        <Button className="pull-right btn right20 btn-default"
                                type="button"
                                onClick={() => this.setState({
                                    activitiesListModalVisible: false
                                })}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </div>
}

export function prepareModelsOptions() {
    let allModels = [];
    const {GBGProductsBrand} = this.state.screensData;
    if (GBGProductsBrand) {
        const foundItem = this.state.allBrandsWithModels.find(item => item.value == GBGProductsBrand);
        allModels = foundItem ? foundItem.Models : [];
    } else {
        this.state.allBrandsWithModels.forEach(record => {
            allModels = allModels.concat(record.Models);
        })
    }
    this.modelsList = prepareSelectOptionsList(
      allModels.map(model => {
          return {label: model, value: model};
      }),
      {
          label: 'label',
          value: 'value'
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label);
    });
    this.setState({});
}

export function  displayNavigation(){
    if ( this.state.screensStack.length==1){
        return
    }

    if (config.getEnvironmentName() !== 'local' &&_.includes([SCREENS.barcode_printing_screen.key],this.state.currentScreen)){
        return
    }
    return <div className="screen-navigation-box">

        {  this.state.screensStack.map((screen, index) => {
            const screenTitle = SCREENS[screen].getTitle ? SCREENS[screen].getTitle(this) : SCREENS[screen].title;
            return <span>
               {index !== 0 && /* 8674*/
               <span className="pleft5 pright5 purple font-size-19" style={{position:'relative',top:-1}}>&#8702;</span>
               }
                <span   onClick={(e)=>{
                    if(screen ==this.state.currentScreen){
                        return;
                    }
                    this.setState({currentScreen:screen})
                }  } className={classNames('navigation-item ', {'cursor-pointer':screen !== this.state.currentScreen,
                    green:screen !== this.state.currentScreen,
                    //   'orange':index%2,
                    pink:screen == this.state.currentScreen})} >{screenTitle}</span>
           </span>
        })}
    </div>
}
export function  processScannedData(data,  params={}) {
    return new Promise((resolve, reject) => {
console.log('processScannedData', data,params  );
        var userMessage = '', self = this
        self.setState({pending: true})
        if (params.ScanAction == 'ScanPartnerProduct') {
           // data = 'BLPALLET11'
            var match = data
            if (params.TrackingServiceType == 'FedEx') {
                /* get 12 last digits from the number */
                if (data.length < 12) {
                    userMessage = 'Can not process number ' + data + '. FedEx number must include more than 12 characters'
                } else {
                    data = data.slice(-12)
                }
            }
        } else   if (params.ScanAction == 'ScanBarcodeNumber') {
            console.log('config.getEnvironmentName()', config.getEnvironmentName(), params.override);
            if ( config.getEnvironmentName() == 'local1' &&  !params.override) {
                data = '20.391.238'
                data ='20.288.15'
                  data = '9992386.1.31'   /* pallet product */
            } else if (data == '869.1.1 ') {

                data = '20.3.106'

            }

            console.log('data', data);
            var match = data.match(/^[\s]*(\d+)\.(\d+)\.(\d+)\.(\d+)[\s]*$/)
            if (match) {
                console.log('match location', match);
            } else {
                var match = data.match(/^[\s]*(\d+)\.(\d+)\.(\d+)[\s]*$/)
            }
        }
        console.log('match', match);
        if (!userMessage && match) {
            if (params.ScanAction == 'ScanPartnerProduct') {
                return resolve()
            } else if (params.ScanAction == 'ScanBarcodeNumber') {
                getDataForScannedProduct.call(self, {
                    'SellerNumber': match[1],
                    'SellerPickupNumber': match[2],
                    ProductNumber: match[3],
                    SKUsearchText: match[1] + '.' + match[2] + '.' + match[3], /* if product is not found, try to find it for predefined seller numbers*/
                    lookup: ['Pickup', 'SellerID', 'PalletID', 'GBGProduct', 'CreatedByUserID', 'SaleTransactions'],

                    //addFields:[ 'LatestSaleTransaction'],
                    status: 'all',
                    quantity: 'all'
                }).then((foundProduct) => {
                    self.setState({pending: false})
                    if (foundProduct.error) {
                        this.props.displayMessage({
                            'messageCode': foundProduct.error
                        });
                        reject()
                        return
                    }

                    const foundSellerAndPickup = this.props.allSellerPickupsListReducer.data.find(item=>{
                        const {SellerID = {}, SellerPickupNumber = 'n/a'} = item;
                        return parseInt(match[1]) == SellerID.SellerNumber && parseInt(match[2]) == SellerPickupNumber;
                    });

                    if(!foundSellerAndPickup) {
                        self.props.displayMessage({
                            messageType: 'warning',
                            messageCode: 'Seller and pickup records not found'
                        });
                        return getAllSellerPickupsList.call(self);
                    }

                    if (foundProduct._id) { /* if product  exists */
                        if (config.getEnvironmentName() !== 'local1' && this.state.currentFlow == "PostingFlow" && _.includes(_.get(foundProduct, 'ShopifyProductID', '',), 'temporary') && 'PartnerConsigned' == _.get(foundProduct, 'SellerID.InventoryOwnership') && _.get(foundProduct, 'TrackingNumbers', []).length == 0) {
                            return self.props.displayMessage({
                                'messageCode': 'Product can not be posted as it does not include tracking number'
                            });
                        }

                        const {OriginalImages} = foundProduct;

                        let screenDataToSet = {CurrentProductData: foundProduct, imagesToDelete: [], ScanAction: '',currentServiceRecord: foundSellerAndPickup};
                        let foundProductItem = false;
                        if (match[4]) {
                            foundProductItem = _.find(_.get(foundProduct, 'ProductItems', []), productItem => {
                                return productItem.ProductItemSKU == match[1] + '.' + match[2] + '.' + match[3] + '.' + match[4];
                            });

                             if (!foundProductItem) {
                                return self.props.displayMessage({'messageCode': 'SKU with location number ' + match[4] + ' not found in this product'})
                            }

                        } else {
                            foundProductItem = _.find(_.get(foundProduct, 'ProductItems', []), productItem => {
                                return productItem.ProductItemSKU == match[1] + '.' + match[2] + '.' + match[3];
                            });
                        }

                         if (foundProductItem) {
                             screenDataToSet.CurrentProductData.currentProductItem = foundProductItem;
                        }

                        if (_.includes(_.get(foundProduct, 'ShopifyProductID', '',), 'temporary') && _.isUndefined(foundProduct.ProductListingID) && _.get(foundProduct, 'TrackingNumbers.0.Disposition')) {
                            return self.props.displayMessage({'messageCode': ' ' })

                        } else {

                            if (_.get(foundProduct, 'PalletID._id')) {
                                if (_.get(foundProduct, 'PalletProductData.PalletProductStatus', '') == 'Checked') {
                                    if (_.isUndefined(foundProduct.ProductListingID) && foundProduct.ShopifyProductID.includes('temporary')) {/* to differentiate pallet product prelistings and listings from original pallet products */
                                        const {PalletID = {}} = foundProduct;
                                        var additionalData = {
                                            OriginalProductID: foundProduct._id,
                                            ProductItems: _.get(foundProduct, 'ProductItems', []),
                                            PalletID:PalletID
                                        }
                                        if (_.get(foundProduct, ['ProductVariants', 0, 'Quantity'], 0) > 1) {
                                            additionalData.ConfirmPalletProductQuantity = _.get(foundProduct, ['ProductVariants', 0, 'Quantity'], 0)
                                        }

                                         this.goToPrelistingFlow({
                                            match: match,
                                            foundSellerAndPickup,
                                            additionalData: additionalData
                                        })
                                        this.setState({BarcodeNumber: '', currentAction: '',});
                                        return;
                                    }
                                } else {/* if pallet product is not 'Checked', go to pallet product confirmation screen */

                                    screenDataToSet.images = OriginalImages.map(originalImage=>{
                                        return {
                                            _id: originalImage._id,
                                            imageStatus: 'savedInDatabase',
                                            imageID: originalImage._id,
                                            mime: mime.lookup(originalImage.URL),
                                            size: originalImage.Size,
                                            type: _.get(originalImage, ['Type'], ''),
                                            s3FileURL: originalImage.URL,
                                            fullUri: originalImage.URL,
                                            uploadProgress: 1
                                        };
                                    });
                                    prepareReduxDataForProduct.call(this, screenDataToSet).then(() => {
                                        _.set(screenDataToSet, 'CurrentProductData.OriginalProductID', foundProduct._id);
                                        screenDataToSet.PalletProductProcessing = true;
                                        self.setScreensData(screenDataToSet,
                                            function () {
                                               self.goToNextScreen(SCREENS.pallet_confirmation_screen.key);
                                            })
                                    });
                                   return;
                                }
                            }

                             if ( this.state.currentFlow == 'PostingFlow' && ((foundProduct.ShopifyProductID.includes('temporary') && foundProduct.ProductListingID) || _.get(foundProduct, 'ShopifyProductHandle', '',) )) { /* this is a listing  or pre-listing */
                                const userImages = OriginalImages.find(image => {
                                    return _.get(image, 'Type') == 'User'
                                })

                                if ( config.getEnvironmentName() !== 'local' && !userImages) { /* photo upload screen */
                                    self.props.displayMessage({
                                        messageType:'warning',
                                        messageCode: 'Please, upload photos for this product with the app'
                                    });

                                }else{
                                    if ((foundProduct.ShopifyProductID.includes('temporary') && foundProduct.ProductListingID)) {
                                        self.props.displayMessage({
                                            messageType: 'warning',
                                            'messageCode': 'Finalizing is not yet available. Please, finalize this pre-listing in the app'
                                        });
                                    }else{
                                        self.props.displayMessage({
                                            messageType: 'warning',
                                            'messageCode': 'Editing is not available. Please, edit this listing in the app'
                                        });
                                    }
                                }
                            }
                        }


                    } else { /* if product not found */
                            if (this.state.currentFlow == 'PuttingAwayFlow') {
                                return this.setState({
                                    customModalType: 'selectPostingFlow',
                                })
                            }

                            if (config.getEnvironmentName() == 'production' && self.state.currentFlow == "PostingFlow" && 'PartnerConsigned' == _.get(foundSellerAndPickup, 'SellerID.InventoryOwnership')) {
                                self.setState({pending: false})
                                return self.props.displayMessage({
                                    'messageCode': 'Tracking number must be first added for a new product'
                                });
                            }

                            let additionalData = {};

                            if(foundSellerAndPickup && foundSellerAndPickup.PalletID) {
                                additionalData.PalletID = foundSellerAndPickup.PalletID;
                            }

                            this.goToPrelistingFlow({match: match, foundSellerAndPickup, type: 'new_prelisting',additionalData});
                    }

                })
            }

            } else {
                var message = userMessage ? userMessage : 'Can not parse data: ' + data

                console.log('can not parse', data);
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': message
                });
                reject()
            }


    })
}
 export function getAllSellerPickupsList(params = {}) {
     var self = this;
     var methodData = {
         timeout: 85000,

         "endpoint": "/pickups",
         'not_display_success_message': true
     };
     return this.props.makeRequest(_.extend({
         all: true,
         sortBy: 'SellerID.DisplayName:1',
         StatusesToExclude: [
             'Cancelled', 'Active', 'Archived'],
         sortBySecondary: 'SellerPickupNumber:1',
         include : ['SellerID.SellerNumber','SellerID.PartnerData','SellerID.DisplayName', 'HasUsedCarSeat',
           'CarSeatAttestationSigned','UsedCarSeatAttestationURL',
           'MarketName',  'SellerPickupNumber','SellerID._id', '_id','SellerID.InventoryOwnership', 'PalletID'],
         lookup: ['Sellers']
     }, params), methodData).then(response => {
         // _.map(response.data.data, item=>{
         //     return {
         //         "_id": 1,
         //         "DisplayName": item.SellerID.DisplayName,
         //         "createdAt": item.createdAt,
         //         "updatedAt":  item.updatedAt,
         //         "PickupAddress" : item.SellerID.PickupAddress,
         //         "SellerNumber":item.SellerID.SellerNumber,
         //         "Pickups": item,
         //     }
         // })
         if (params.fromUpdatedAtTime) {

             if (response.data.data.length) {
                 var updatedList = _.uniqBy(_.concat(response.data.data, this.props.allSellerPickupsListReducer.data), '_id')
                 /* get all services that were updated or created since   allSellerPickupsListLastUpdated */
                 var allSellerAndPickupData = _.orderBy(updatedList, ['SellerID.DisplayName', 'SellerPickupNumber'], 'asc')
                 self.props.dispatchAction({'data': allSellerAndPickupData}, FETCH_ALL_SELLER_PICKUPS_LIST)

             }
         } else {
             var allSellerAndPickupData = _.orderBy(response.data.data, ['SellerID.DisplayName', 'SellerPickupNumber'], 'asc')
             self.props.dispatchAction({'data': allSellerAndPickupData}, FETCH_ALL_SELLER_PICKUPS_LIST)

         }
     }).catch(err => {

         console.log('err', err);
     });
 }
 export  function prepareReduxDataForProduct(dataToUpdate) {
     return new Promise((resolve, reject) => {
          var productData = dataToUpdate.CurrentProductData;
         this.doNotLookUpForAmazonProducts = false;
         dataToUpdate.images = _.map(_.get(productData, 'OriginalImages', []), function (originalImage) {
             return {
                 _id: originalImage._id,
                 imageStatus: 'savedInDatabase',
                 imageID: originalImage._id,
                 mime: mime.lookup(originalImage.URL),
                 size: originalImage.Size,
                 type: _.get(originalImage, ['Type'], ''),
                 ShopifyImageURL: _.get(originalImage, ['ShopifyImageURL'], ''),
                 OriginalS3FileURL: originalImage.URL,
                 s3FileURL: originalImage.URL,
             //    smallImageURL: originalImage.ShopifyImageURL ? getShopifyImageBySize(originalImage.ShopifyImageURL, 'small') : '',
             //    largeShopifyImageURL: originalImage.ShopifyImageURL ? getShopifyImageBySize(originalImage.ShopifyImageURL, 'large') : '',
                 fullUri: originalImage.URL,
                 uploadProgress: 1
             };
         });
         if (_.get(dataToUpdate.CurrentProductData, 'CustomData.ConditionValue')) {
             productData.Condition = _.get(dataToUpdate.CurrentProductData, 'CustomData.ConditionValue')
         }

         dataToUpdate.Details = _.get(productData, 'Details', '')
         /* used to add a tag on PostScreen */
         dataToUpdate.selectedGBGProduct = _.get(productData, ['GBGProductID'], false);

         dataToUpdate.ProductAgeRange = _.map(_.get(productData, 'ProductAgeRange', []), (tag) => {
             return {label: tag, value: tag}
         })
         dataToUpdate.ProductCategories = _.get(productData, 'Categories', [])

         var promise = Promise.resolve(true)
         if (productData.ProductListingID){/* this is pre-listing*/
             dataToUpdate.productAction = 'PostPrelisting'
             dataToUpdate.ProductID = productData.ProductListingID

             if (_.get(dataToUpdate, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle' || _.find(_.get(productData, ['Categories'], []), item => {
                     return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory)
                 })) {
                 this.doNotLookUpForAmazonProducts = true;
             }
             console.log('this.doNotLookUpForAmazonProducts 1', this.doNotLookUpForAmazonProducts);

             if (_.get(dataToUpdate, ['selectedGBGProduct'], false)) {
                 promise = getAmazonProductData.call(this,
                     _.get(dataToUpdate, ['selectedGBGProduct', 'OriginalProductData', 'ASIN']), dataToUpdate)
             }
         } else if (_.includes(_.get(productData, 'ShopifyProductID', '',), 'temporary')) { /* can  go into this condition when called from In Progress tab for pre-prelisting*/
             dataToUpdate.productAction = 'AddPrelisting'
             dataToUpdate.ProductID = uuidv4()
             dataToUpdate.SKU = _.get(dataToUpdate.CurrentProductData, 'SellerID.SellerNumber', '') + '.' + _.get(dataToUpdate.CurrentProductData, 'PickupID.SellerPickupNumber', '') + '.' + _.get(dataToUpdate.CurrentProductData, 'ProductNumber', ''),
                 dataToUpdate.ProductNumber = _.get(dataToUpdate.CurrentProductData, 'ProductNumber')
             dataToUpdate.SellerID = _.get(dataToUpdate.CurrentProductData, 'SellerID._id')
             dataToUpdate.PickupID = _.get(dataToUpdate.CurrentProductData, 'PickupID._id')
         } else {/*  edit listing*/
             dataToUpdate.productAction = 'EditListing'
             dataToUpdate.ProductID = base64ToHex(productData._id)
         }
         return promise.then(data => {
             resolve(dataToUpdate)
         }).catch(err => {
             console.log('err', err  );
            reject(err)
         })
     })
 }
export function   getDataForScannedProduct(params) {
    return new Promise((resolve, reject) => {
        this.props.makeRequest(params, {
            'endpoint': '/products',
            timeout: 25027,
            'not_display_success_message': true
        }).then((res) => {
            // console.log('getdataforscanned product', res.data);
            if (_.get(res.data, 'total', 0) > 1) {
                if (res.data.total == 2 && ((params.SellerNumber == '20' && params.SellerPickupNumber == '5') || config.getEnvironmentName() == 'local')) {
                    return resolve(res.data.data[1])
                }
                resolve({error: res.data.total + ' products found'})
            } else if (_.get(res.data.data, ['0', '_id'])) {
                return resolve(res.data.data[0])
            } else {

                resolve({})


            }

        }).catch((error) => {
            resolve({error: 'Sorry, can not find product. Something went wrong'})
        })
    })
}

export function searchGBGProducts(params = {}) {
    console.log('searchGBGProducts', this.state.screensData.GBGProductsearchText  );
    var self = this, queryParams = {perPage:20};
    if (!_.isUndefined(params.page) && params.page !== 1) {
        queryParams.page = params.page;
    }
    //  self.setScreensData({GBGProductsFetched:false})
    var methodData = {
        'endpoint': '/gbg_products',
        timeout: 25019,
        'success_event_data': {
            'page': params.page ? (isNaN(params.page) ? 1 : params.page) : 1,
        },
        'not_display_success_message': true
    };
    queryParams.sortBy = 'Model:1'
    if (_.get( self.state.screensData, 'GBGProductsBrand')  ) {
        queryParams.Brands = [self.state.screensData.GBGProductsBrand]
    }
    if (_.get( self.state.screensData, 'GBGProductsModel')  ) {
        queryParams.Models = [self.state.screensData.GBGProductsModel]
    }
    if (self.state.screensData.GBGProductsearchText) {
      //  queryParams.searchText =_.trim(self.state.screensData.GBGProductsearchText)
        queryParams.indexSearchText =_.trim(self.state.screensData.GBGProductsearchText)
        queryParams.sortBy = 'textIndexScore:-1'
    }
    if (params.customParams) {
        queryParams = params.customParams

    }
    return  this.props.makeRequest(queryParams, methodData).then((res) => {
         if (params.returnGBGProductsData) {
            return res.data.data

        }
        if (res.data.total >0  ) {
            self.setScreensData({   GBGProductsData: res.data.data,
                GBGProductsTotal: res.data.total,
                GBGProductsPage:_.get(queryParams,'page',1) -1,
                listingsFetched:false,
                GBGProductsFetched: true})
            // this.searchProducts({returnProductData:true, GBGProductIDs:_.map(res.data.data,'_id')}).then(foundListings=> {
            //     console.log('foundListings w', foundListings);
            //     var GBGProductIDsForListings = _.uniq(_.map(foundListings, 'GBGProductID'))
            //     res.data.data = _.filter(res.data.data, item => {
            //         return _.includes(GBGProductIDsForListings, item._id)
            //     })
            //     res.data.total = res.data.data.length
            //     console.log('filteredGBGProducts after filter', res.data.data);
            //     self.setScreensData({   GBGProductsData: res.data.data,
            //         GBGProductsTotal: res.data.total,
            //         GBGProductsFetched: true})
            // }).catch(err=>{
            //     console.log('err', err  );
            // })
        } else {
            self.setScreensData({
                GBGProductsTotal: res.data.total,
                GBGProductsPage:_.get(queryParams,'page',1) -1,
                GBGProductsFetched: true})
        }


    }).catch(err => {
        return Promise.reject(err)

    });
}



 export var searchGBGProductsDebounce =   _.debounce(searchGBGProducts, 1000, {
     /* to not trigger startTimeTrackingInterval two times (one of them in willReceiveProps) when user presses on Start button */
     'leading': true,
     'trailing': true
 });

 function locationInWarehouseTextCallbackMethod( ){

     if (this.state.currentFlow == '3PLProcessingFlow') {
         console.log('CurrentPartnerProductData', _.get(this.state.screensData, 'CurrentPartnerProductData._id')  );
         if (_.get(this.state.screensData, 'CurrentPartnerProductData._id')) {
             this.goToNextScreen(SCREENS.tracking_number_quantity_screen.key)
         }else{
             this.goToNextScreen(SCREENS.confirmation_screen.key)
         }
     }else{
         this.goToNextScreen(SCREENS.confirmation_screen.key)
     }

 }
 export var locationInWarehouseTextCallback =   _.debounce(locationInWarehouseTextCallbackMethod, 600, {
     'leading': false,
     'trailing': true
 });
 function  trackingNumberScannedCallbackMethod( ) {
      var self =this;
     if (this.state.pending){
         return;
     }

     var SKUmatch = this.state.screensData.TrackingNumber.match(/^[\s]*(\d+)\.(\d+)\.(\d+)(\.(\d+))?[\s]*$/)
     if(SKUmatch){
         return this.props.displayMessage({
             'messageCode': 'Please scan the tracking number or pallet barcode, not the product SKU'
         });
     }
     var trackingNumberToSet =this.state.screensData.TrackingNumber
     if (self.state.screensData.TrackingServiceType== 'FedEx') {
         /* get 12 last digits from the number */
         if (trackingNumberToSet.length >12) {
             trackingNumberToSet = trackingNumberToSet.slice(-12)
         }
     }

     processScannedData.call(self,trackingNumberToSet,   {TrackingServiceType:
         self.state.screensData.TrackingServiceType,
         ScanAction:'ScanPartnerProduct'}).then((processedData)=> {

         self.setScreensData({TrackingNumber:trackingNumberToSet, TrackingNumbers: [{
                 //  ProductItemID:uuidv4(),
                 TrackingNumber: trackingNumberToSet}],}, () => {
             self.goToNextScreen(SCREENS.conditions_screen.key)
         })
     }).catch(err=>{
         self.setState({pending:false})
     })

 }
 export var trackingNumberScannedCallback =   _.debounce(trackingNumberScannedCallbackMethod, 600, {
     'leading': false,
     'trailing': true
 });

 function barcodeScanningTextCallbackMethod(text){
     console.log('barcodeScanningTextCallback text', text  );
     var self = this;
     const BarcodeNumber = this.state.screensData.BarcodeNumber.trim()
     self.setScreensData({BarcodeNumber})
     processScannedData.call(self, BarcodeNumber,   {
         ScanAction:'ScanBarcodeNumber'}).then(()=> {
         self.setScreensData({}, () => {
             self.goToNextScreen(SCREENS.conditions_screen.key)
         })
     }).catch(err=>{
         self.setState({pending:false})
     })

 }
 export var barcodeScanningTextCallback =   _.debounce(barcodeScanningTextCallbackMethod, 600, {
     'leading': false,
     'trailing': true
 });
 export function prepareDataForDonation(){
     return new Promise((resolve, reject) => {
         var self = this;
         this.getNextSKU().then(nextProductNumber => {
            var dataToUpdate = {
                 ProductCategories: [{Category: 'Donate'}],
                 CurrentPartnerProductData: {},
                 nextProductNumber: nextProductNumber,
                 OriginalPrice: 0,
                images:[],/* no images must be passed from GBG Products*/
                 Shippable: false,
                 QualityCheckInstructions: [{'Action': 'DONATE'}],

             }

             //This is the data that will be overwrite by donation.
             let screenData = self.state.screensData;
             if(screenData.GBGProductsBrand != "Unkown" && self.FeatureFlags.EnableSaveOriginalDonationData){
                 let selectedGBGProduct = screenData.selectedGBGProduct || {}
                 dataToUpdate.DonationInventoryMetadata = {
                    GBGProductID: selectedGBGProduct._id,
                    Brand: screenData.GBGProductsBrand,
                    Model: screenData.GBGProductsModel,
                    Description: screenData.Description,
                    ProductCategories: screenData.ProductCategories,
                    GBGProductImage: screenData.GBGProductImage,
                    ProductAgeRange: screenData.ProductAgeRange,
                    RetailProductPrice: (selectedGBGProduct.OriginalProductData || {}).RetailProductPrice,
                    AmazonProductPrice: (selectedGBGProduct.OriginalProductData || {}).AmazonProductPrice,
                    OriginalPrice: formatNumbers.unformat(screenData.OriginalPrice || ""),
                    PersonalNote: screenData.PersonalNote,
                    SelectedModelVariations: screenData.selectedModelVariations,
                    Details: screenData.Details,
                    UPCCode: selectedGBGProduct?.OriginalProductData.UPC || screenData.upcCodeToSave
                 }
             }

             dataToUpdate.Description =dataToUpdate.PersonalNote = 'Does not meet minimum value/quality threshold, or Unsafe (e.g. recalled, broken, missing parts, unsanitary), or not a baby/kid related item.' +
                 ' Please contact us ASAP if you would like to pick these items up. If we hear from you within 24 hours of this posting we can hold them for up to 5 days.' +
                 ' Otherwise we will donate them to one of our amazing non-profit partners.'
             dataToUpdate.Condition = 5;
             dataToUpdate.currentConditionRating = 45;

             return searchGBGProducts.call(self,{
                 customParams: {searchText: 'Donate'},
                 returnGBGProductsData: true
             }).then(matchingGBGProducts => {

                  var donationGBGProduct = _.find(matchingGBGProducts, function (GBGProduct) {
                     if (_.find(_.get(GBGProduct, ['Categories'], []), item => {
                             return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory)
                         })) {
                         if (GBGProduct.Model.toLowerCase().includes('to sell')) {
                             return true
                         }
                     }
                 })
                  if (donationGBGProduct) {
                     dataToUpdate = _.extend(dataToUpdate, {
                         selectedGBGProduct: donationGBGProduct,
                         ProductCategories: prepareProductCategories.call(self, {
                             selectedGBGProduct: donationGBGProduct,
                             AllCategories: self.state.AllCategories,
                         }),
                         modelVariations: {},
                         ProductName: (_.get(donationGBGProduct, ['Brand']) == 'Unknown' ? '' : _.get(donationGBGProduct, ['Brand']) + ' ') + _.get(donationGBGProduct, ['Model']),
                          GBGProductsBrand: donationGBGProduct.Brand,
                         GBGProductsModel: donationGBGProduct.Model
                     })
                     //   dataToUpdate.GBGProductFound = true
                     //  dataToUpdate.ProductName = _.get(donationGBGProduct, 'Brand') + ' ' + _.get(donationGBGProduct, 'Model')
                 } else {
                       this.props.displayMessage({
                         'messageType': 'warning',
                         'messageCode': 'Can not find GBG Product'
                     });
                       return reject()
                 }

                 resolve(dataToUpdate)
             })
         }).catch(err=>{
             return reject(err)
         })
     })
 }
function assignGBGProductImagesToQualityChecks(qualityChecks){
    const {GBGProductImages=[]} = this.state.screensData.selectedGBGProduct ? this.state.screensData.selectedGBGProduct : {}
    let conditionsByNumber = {}
    let conditionsByText = {}
    GBGProductImages.forEach(GBGProductImage=> {
        const {ConditionsToMatch = []} = GBGProductImage
        ConditionsToMatch.forEach(conditionToMatch => {
            const {Conditions = []} = conditionToMatch
            Conditions.forEach(condition => {
                if (condition.QualityCheckNumber) {
                     if(conditionsByNumber[condition.QualityCheckNumber]){
                        conditionsByNumber[condition.QualityCheckNumber].push(GBGProductImage)
                    }else{
                        conditionsByNumber[condition.QualityCheckNumber] = [GBGProductImage]
                    }
                } else if (condition.QualityCheckText) {
                    if(conditionsByText[condition.QualityCheckText]){
                        conditionsByText[condition.QualityCheckText].push(GBGProductImage)
                    }else{
                        conditionsByText[condition.QualityCheckText] = [GBGProductImage]
                    }
                 }
            })
        })
    })
    const updatedQualityChecks = qualityChecks.map(qualityCheckItem=>{
        let {QualityCheckImages = [],ItemNumber = '',Text } = qualityCheckItem
        let imagesForGBGProduct = []
        if (conditionsByNumber[ItemNumber]){
            imagesForGBGProduct = imagesForGBGProduct.concat(conditionsByNumber[ItemNumber]);
        }else if(conditionsByText[Text]) {
            imagesForGBGProduct = imagesForGBGProduct.concat(conditionsByText[Text]);
        }
        if(imagesForGBGProduct.length){
            QualityCheckImages = imagesForGBGProduct
        }
        return {...qualityCheckItem,QualityCheckImages:QualityCheckImages}
    })
    return updatedQualityChecks
}
export function getQualityChecksForGBGProduct(stateData, customParams = {}) {
    var OriginalPrice = 'not_available'
    const {selectedGBGProduct = {}} = stateData;
    const {MatchingQualityChecksOrder = []} = selectedGBGProduct;
    if (_.get(stateData, 'selectedGBGProduct.OriginalProductData.RetailProductPrice')) {
        OriginalPrice = _.get(stateData, 'selectedGBGProduct.OriginalProductData.RetailProductPrice')
    } else if (_.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice')) {
        OriginalPrice = _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice')
    }else if (_.get(stateData, 'selectedSearchAPIProduct.name') && _.get(stateData,'OriginalPrice')) {
        /* if RetailProductPrice or AmazonProductPrice is not available yet and user selected Amazon product, use its price*/
        OriginalPrice = _.get(stateData,'OriginalPrice')
    }
    // }
    console.log('OriginalPrice', OriginalPrice  );
    return new Promise((resolve, reject) => {
        if(config.getEnvironmentName() == 'local1'){
            return resolve({
                data: [], qualityCheckQueryParams: ''
            })
        }

        let currentServiceRecord = this.state.screensData.currentServiceRecord || {};
        const {InventoryOwnership } = currentServiceRecord.SellerID || {};
        let params = {
            includeRecordWithEmptyCategoryTags: true,
            // sortBy: 'createdAt:-1',
            includeRecordWithEmptySellerInventoryOwnership:true
        };
        if (_.get(stateData, 'selectedGBGProduct._id')) {
            if (OriginalPrice == 'not_available') {/* if Price is not available, try to filter by categories, if they are selected */
                if (_.size(_.get(stateData, ['ProductCategories'], [])) > 0) {
                    params.Categories = _.get(stateData, ['ProductCategories'], [])
                    //  if (_.size(_.get(stateData, 'selectedGBGProduct.CategoryTags', [])) > 0) {
                    //    params.CategoryTags = _.get(stateData, 'selectedGBGProduct.CategoryTags', [])
                    // }
                    params.MatchingType = ['Matching', 'GBGProductNotFound']
                } else {
                    params = {MatchingType: ['GBGProductNotFound']}
                }
                this.setState({
                    pricingOverrideConditions: {
                        /* update pricingOverrideConditions to not call getQualityChecksForGBGProduct several times in UNSAFE_componentWillReceiveProps */
                        selectedModelVariations: [],
                        Condition: stateData.Condition
                    }
                })
            } else {

                console.log('OriginalPrice', OriginalPrice);


                if (_.size(_.get(stateData, ['ProductCategories'], [])) > 0) {
                    params.Categories = _.get(stateData, ['ProductCategories'], [])
                }
                if (_.size(_.get(stateData, 'selectedGBGProduct.CategoryTags', [])) > 0) {
                    params.CategoryTags = _.get(stateData, 'selectedGBGProduct.CategoryTags', [])
                }
                // else {
                //     params.CategoryTags = ['NoCategoryTag']
                // }
                params.Brand = _.get(stateData, 'selectedGBGProduct.Brand', undefined)
                params.Model = _.get(stateData, 'selectedGBGProduct.Model', undefined)
            }
        } else {
            console.log('gbg product not found'   );
            if (_.size(_.get(stateData, ['ProductCategories'], [])) > 0) {
                params.Categories = _.get(stateData, ['ProductCategories'], [])
                params.MatchingType = ['Matching', 'GBGProductNotFound']
            } else {
                params = {MatchingType: ['GBGProductNotFound']}
            }
        }

        if (InventoryOwnership) {
            params.SellerInventoryOwnership = [InventoryOwnership];
        }

        if (_.get(stateData, 'selectedGBGProduct.QualityChecksMatchingRules.SellerInventoryOwnership',[]).length){
            console.log('selectedGBGProduct 1', _.get(stateData, 'selectedGBGProduct.QualityChecksMatchingRules.SellerInventoryOwnership')  );
            params.SellerInventoryOwnership = _.get(stateData, 'selectedGBGProduct.QualityChecksMatchingRules.SellerInventoryOwnership')
        }
        console.log('customParams', customParams);
        if (!_.isEmpty(_.get(customParams, 'additionalQualityChecksQueryParams', {}))) {
            params = _.extend(params, customParams.additionalQualityChecksQueryParams)
        }

        if(MatchingQualityChecksOrder.length) {
            params.matchingQualityChecksOrder = MatchingQualityChecksOrder;
        }

        if(customParams.customQualityChecksToInclude.length) {
            params.customQualityChecksToInclude = customParams.customQualityChecksToInclude;
        }

        var methodData = {
            'endpoint': '/match_quality_checks',
            timeout: 25028,
            type: 'post',
            'not_display_success_message': true,
        };

         if(this.FeatureFlags.DeterministicCondition) {
            params.prepareQualityCheckList = true;
        }
        this.props.makeRequest({...params, all: true}, methodData).then((response) => {
             let matchingQualityChecks =  assignGBGProductImagesToQualityChecks.call(this, response.data.data);
                const data  = _.sortBy(matchingQualityChecks.map( item => {
                    return {...item, checked: false}
                }, 'Text'))
              const qualityCheckQuery = _.omit(params, ['includeRecordWithEmptyCategoryTags'])
            const result = { data: data, qualityCheckQueryParams: qualityCheckQuery }
              resolve(result)
        }).catch(function (err) {
            resolve({data: []})
        })
    })
}

export async function processQualityChecks(qualityCheckItems) {
    let qualityCheckToDisplay = prepareCarSeatQualityChecks.call(this,qualityCheckItems);

     if(!qualityCheckToDisplay) {
         qualityCheckToDisplay = await checkQualityCheckRules.call(this);
     }

    if (qualityCheckToDisplay) {
        return [{
            _id: 'hd9vnkU8SFyOlQEwWFYaAw==',
            Text: qualityCheckToDisplay.text,
            ItemNumber: '',
            qualityCheckType: 'Custom',
            DeterministicQualityCheck: {
                Answers: [{
                    AnswerText: qualityCheckToDisplay.buttonText || 'Confirm',
                    Penalty: parseFloat(qualityCheckToDisplay.penalty)
                }]
            }
        }];
    }

    return qualityCheckItems;
}

function prepareCarSeatQualityChecks(qualityCheckItems) {
    const {currentServiceRecord = {}} = this.state.screensData;
    let foundCarSeatQCIndex = qualityCheckItems.findIndex(item => {
        return item.CustomHTML && item.CustomHTML.toLowerCase().includes('car_seat_attestation_url');
    });
    const {CustomQualityChecks = []} = this.ProductsSettingsData || {};

    if (this.props.appData.FeatureFlags.EnableCarSeatsProcessing &&  foundCarSeatQCIndex !== -1) {
        if (currentServiceRecord.PalletID) {
            qualityCheckItems.splice(foundCarSeatQCIndex, 1); /* remove this element from array */
        } else {
            const iframeSrc = (currentServiceRecord.UsedCarSeatAttestationURL) ?
                currentServiceRecord.UsedCarSeatAttestationURL :
                '/theme/assets/attestation_not_signed.png';

            qualityCheckItems[foundCarSeatQCIndex].CustomHTML = qualityCheckItems[foundCarSeatQCIndex].CustomHTML.replace(/car_seat_attestation_url/i, iframeSrc);

            if (!currentServiceRecord.HasUsedCarSeat) {
                return CustomQualityChecks.find(item=>item.slug == 'car_seat_checkbox_not_selected');
            }

            if (!currentServiceRecord.CarSeatAttestationSigned) {
                return CustomQualityChecks.find(item=>item.slug == 'car_seat_attestation_not_filled_out');
            }
        }
    }
}

async function checkQualityCheckRules() {
    let matchingQualityCheckRule;
    const {selectedGBGProduct = {}, currentServiceRecord = {}} = this.state.screensData;
    const {SellerID = {}} = currentServiceRecord;
    let dataToCheck = {
        inventoryOwnership: SellerID.InventoryOwnership,
        palletID: currentServiceRecord.PalletID || 'not_assigned'
    };
    const {QualityCheckRules = []} = this.ProductsSettingsData || {};
    const {OriginalProductData = {}} = selectedGBGProduct;
    dataToCheck.originalPrice = 0;

    if (!_.isUndefined(OriginalProductData.RetailProductPrice)) {
        dataToCheck.originalPrice = OriginalProductData.RetailProductPrice;
    } else if (!_.isUndefined(OriginalProductData.AmazonProductPrice)) {
        dataToCheck.originalPrice = OriginalProductData.AmazonProductPrice;
    }
    matchingQualityCheckRule = QualityCheckRules.find(({conditions = []}) => {
        const correctStatements = conditions.filter(async ({operator, field, customData = {}, value}) => {
            const compareFunction = config.operatorsMap[operator] || (() => false);

            if (field == 'basePrice' && dataToCheck.originalPrice && customData.condition) {
                const condition = config.conditionsData.find((item) => item.value == customData.condition);
                const calculateRecommendedPricesResponse = await calculateRecommendedPrices.call(this, _.extend({
                    OriginalPrice: dataToCheck.originalPrice,
                    Condition: condition.number
                }), this.state.screensData);
                dataToCheck[field] = formatNumbers.unformat(calculateRecommendedPricesResponse.recommendedPrice);
                return compareFunction(dataToCheck[field], value);
            } else {
                return compareFunction(dataToCheck[field], value);
            }
        });
        if (correctStatements.length == conditions.length) {
            return true;
        }
    });

    return matchingQualityCheckRule;
}

function prepareCustomQualityChecks(params, customQualityChecksToInclude) {
  customQualityChecksToInclude.forEach((customQualityCheck) => {
    const { Answers = [], Type = false } = customQualityCheck.DeterministicQualityCheck || {};
    const donationQualityCheck = Answers.some((answer) => answer.Penalty == 100);

    if (donationQualityCheck) {
      customQualityCheck.priority = 1;
    } else if (Type == config.deterministicQualityCheckTypes.ShowFirst) {
      customQualityCheck.priority = 2;
    } else {
      customQualityCheck.priority = 10;
    }
  });
}
 /* Model variations ---> */
 export function prepareModelVariationsToDisplay(params = {}) {
     var self = this, foundGBGProduct, ProductTags = [], existingProductVariations = []

     if (_.get(this.state.screensData, ['productAction'], '') == 'EditListing' || (_.get(this.state.screensData, ['productAction'], '') == 'PostPrelisting' && _.get(this.state.screensData, ['CurrentProductData', 'GBGProductID'], false))) {

         foundGBGProduct = _.get(this.state.screensData, ['CurrentProductData', 'GBGProductID'], false)
         ProductTags = _.get(this.state.screensData, ['CurrentProductData', 'ProductTags'], [])
         if (params.updateWithExistingData) {
             if (_.get(this.state.screensData, ['CurrentProductData', 'ProductVariations'], false)) {
                 existingProductVariations = _.map(this.state.screensData.CurrentProductData.ProductVariations, (existingProductVariation) => { /* for products created earlier use existing Model Variation Tags. If model variation was not added to tags, it will not be available for update*/
                     return existingProductVariation.label + '####' + existingProductVariation.value
                 })
             } else {
                 existingProductVariations = _.filter(ProductTags, (tag) => { /* for products created earlier use existing Model Variation Tags. If model variation was not added to tags, it will not be available for update*/
                     var match = tag.match(/^([^_]*)_([^_]*)$/)
                     /* match tags in a format part1_part2 */
                     if (match) {
                         if (!_.includes(['Shipping Options', 'Condition', 'Brand', 'Age Group'], match[1])) {
                             return true;
                         }
                     }
                 })
             }

         }
     } else {
         foundGBGProduct = _.get(this.state.screensData, ['selectedGBGProduct' ], false)
     }
     var modelVariationsToUpdate = {}, GBGProductVariations = []
     if (foundGBGProduct && _.trim(_.get(this.state, 'NewBrand', '')) == '' && _.trim(_.get(this.state, 'NewModel', '')) == '' && _.size(_.get(foundGBGProduct, ['Variations'], [])) > 0) {
         GBGProductVariations = _.map(foundGBGProduct.Variations, function (variation, index) {
             variation.type = 'GBGProductVariation'
             variation.defaultNewOptionGBGNote = _.get(foundGBGProduct, 'GBGNote', '')
             if (params.updateWithExistingData) { /* used in Edit listing flow */
                 checkModelVariationsToUpdate.call(this, {modelVariationsToUpdate, variation, existingProductVariations})
             }
             if (variation.InputType == 'select' && _.includes(_.get(variation, 'Label', '').toLowerCase(), 'year')) {
                 variation.Options = _.orderBy(variation.Options, item => {
                     if (_.includes(item.value.toLowerCase(), 'pre')) {/* values with pre-, must be moved to the bottom*/
                         return 1
                     }
                     return item.value
                 }, 'desc')
             }
             return variation
         })
     }
     var CategoriesVariations = []
     _.forEach(this.state.screensData.selectedCategories, function (selectedCategory) {
         var CategoryVariations = _.map(_.get(selectedCategory, ['Variations'], []), function (variation) {
             variation.type = 'CategoryVariation'
             if (variation.InputType == 'select' && _.includes(_.get(variation, 'Label', '').toLowerCase(), 'year')) {
                 variation.Options = _.orderBy(variation.Options, item => {
                     return item.value
                 }, 'desc')
             }
             return variation
         })
         if (_.size(CategoryVariations)) {
             CategoriesVariations = _.concat(CategoriesVariations, CategoryVariations)
         }
     })
     var variationsToDisplay = _.uniqBy(GBGProductVariations.concat(CategoriesVariations), function (variation) {
         return variation.Label
         /* if variation.Label match with Category variations, display only one from GBGProductVariations */
     })
      return {
         variationsToDisplay, modelVariationsToUpdate,
     }
 }
 function checkModelVariationsToUpdate(params) {

     _.forEach(params.existingProductVariations, function (existingProductVariation, index) {
         if (_.includes(existingProductVariation, '####')) {
             var existingVariation = _.split(existingProductVariation, '####')
         } else {
             var existingVariation = _.split(existingProductVariation, '_')
         }
         if (existingVariation[0] == params.variation.Label) {
             if (params.variation.InputType == 'select') {
                 var foundOption = _.find(_.get(params.variation, 'Options', []), option => {
                     return option.value.toLowerCase() == existingVariation[1].toLowerCase()
                 })
             } else {
                 var foundOption = true;
                 /* for text input only label should match */
             }
             if (foundOption) {
                 if (params.variation.InputType == 'select') {
                     params.modelVariationsToUpdate[params.variation.Label + '###' + params.variation.type] = {
                         selectedOptions: [{
                             label: existingVariation[1],
                             value: existingVariation[1]
                         }],
                         optionsVisible: false,
                         label: params.variation.Label,
                         UseInTitle: params.variation.UseInTitle,
                         AddTag: params.variation.AddTag,
                     }
                 } else {

                     params.modelVariationsToUpdate[params.variation.Label + '###' + params.variation.type] = {
                         value: existingVariation[1],
                         optionsVisible: false,
                         label: params.variation.Label,
                         UseInTitle: params.variation.UseInTitle,
                         AddTag: params.variation.AddTag,
                     }
                 }
             }
         }
     })
 }
 export function displayCalculatedBoxSize() {
     if( !this.state.screensData.calculatedBoxSize || _.get(this.state.screensData, ['productAction'], '') == 'EditListing'){
         return null
     }
     return       <div   className="flex-box top10">
         <span  className=" right10  text-bold    ">{ 'Recommended Box Size (L W H):  '} </span>
         <span  >
             <span >{ this.state.screensData.calculatedBoxSize.Length   }</span>
             <span >{' x '}</span>
             <span >{this.state.screensData.calculatedBoxSize.Width  }</span>
             <span >{' x '}</span>
             <span   >{this.state.screensData.calculatedBoxSize.Height  }</span>

         </span>
     </div>


 }
 export function displayProductBoxSize() {


     if( this.state.screensData.boxSizeConfirmed &&_.get(this.state.screensData, ['productAction'], '') == 'EditListing'){
         return null
     }
     var productBoxSize = {}
     if (_.get(this.state,'screensData.confirmDimensions') == 'box_size_selected'){
         productBoxSize  =this.state.screensData.productDimensions

     }else {
         var boxSizeTag = _.find(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), function (tag) {
             return _.includes(tag, 'Box_')
         })

         // var productBoxSizeTag = _.find(_.get(this.state.screensData, 'CurrentProductData.ProductTags', []), function (tag) {
         //     return _.includes(tag, 'Box_')
         // })
         //
         // if (productBoxSizeTag) {
         //     boxSizeTag = productBoxSizeTag
         // }
         if(boxSizeTag) {
             if(_.includes(boxSizeTag.toLowerCase(),'mailer')) {
                 productBoxSize =_.get(_.find(config.boxSizeList, item=>{
                     return _.includes(item.label.toLowerCase(), 'mailer')
                 }),'data',{})
             }else {
                 var dimensions = _.split(boxSizeTag.substring(4), 'x')
                 if (dimensions.length == 3) {
                     productBoxSize = {
                         Length: parseFloat(dimensions[0]),
                         Width: parseFloat(dimensions[1]),
                         Height: parseFloat(dimensions[2])
                     }
                 }
             }
         }else if(_.get(this.state.screensData, ['OriginalProductDimensions', 'Length'])){
         console.log('OriginalProductDimensions',  _.get(this.state.screensData, ['OriginalProductDimensions'], []) );
            var dimensionProductSize = _.find(config.boxSizeList, item=>{
                  return  item.compareWithProductDimensions &&  item.data.Length == _.get(this.state.screensData, ['OriginalProductDimensions', 'Length']) && item.data.Width ==_.get(this.state.screensData, ['OriginalProductDimensions', 'Width']) && item.data.Height ==  _.get(this.state.screensData, ['OriginalProductDimensions', 'Height'])
             }  )
             if(dimensionProductSize){
                 productBoxSize = dimensionProductSize.data
             }
          }
     }

     if(_.isEmpty(productBoxSize)){
         productBoxSize ={Length: 'TBD'}
     }
     return       <div onClick={(event) => {
         this.setScreensData({ confirmDimensions: 'select_box_size',   modalTitle:  'Please select the approximate size of this item when folded or broken down',modalType:'SelectBoxSizeModal'})
         this.setState({showCustomContentModal: true})
     }}  className="cursor-pointer  flex-box top10">
             <span  className="   text-bold    ">{ 'Box Size (L W H): '} </span>
         { _.includes([1, 'TBD'],productBoxSize.Length) ?
                 <span className="purple  ">{productBoxSize.Length == 1 ? 'Mailer': productBoxSize.Length.toUpperCase() }</span>   :
             <span className="purple  " >
                 <span  >{ productBoxSize.Length   }</span>
                 <span  >{' x '}</span>
                 <span >{productBoxSize.Width  }</span>
                 <span  >{' x '}</span>
                 <span >{productBoxSize.Height  }</span>
             </span>
         }
     </div>
 }
 export function renderModelVariationOptions(params = {}) {
     var self = this
    const {GBGProductImages =[]}=self.state.screensData.selectedGBGProduct
     var {variationsToDisplay} = prepareModelVariationsToDisplay.call(this, params)
      if (variationsToDisplay.length > 0) {
         return (<div  >
             <div className="pull-right">{displayVariationsSortingToggle(
               this.state.screensData.sortVariationOptions,
               ()=>{
                   self.setState({
                       screensData: {
                           ...self.state.screensData,
                           sortVariationOptions: self.state.screensData.sortVariationOptions == 'desc' ? 'asc':'desc',
                       }
                   });
               }
             )}</div>
                {_.map(variationsToDisplay, function (variation, index) {
                 if (_.isUndefined(variation.InputType) || variation.InputType == 'input') {
                     return <div className="  top30 align-center set-width text-left    "
                                 key={index}>
                             { _.capitalize(variation.Label) }
                             <FormControl
                                className="top5"
                                 placeholder=""
                                 value={_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'value'], '')}
                                 onChange={(e) => {
                                     self.setScreensData({
                                         'modelVariations': {
                                             ...self.state.screensData.modelVariations,
                                             [variation.Label + '###' + variation.type]: {
                                                 ..._.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type], {}),
                                                 value: e.target.value,
                                                 label: variation.Label,
                                                 UseInTitle: variation.UseInTitle,
                                                 AddTag: variation.AddTag,
                                             }
                                         }
                                     })

                                  }}
                                 type="text"/>


                     </div>

                 } else if (variation.InputType == 'select') {
                      const {modelVariations = []} =self.state.screensData
                      const variationName = `${variation.Label}###${variation.type}`;
                      const variationOptions = modelVariations[variationName] || {};
                      const {newOptions=[],selectedOptions=[]} = variationOptions;
                      let selectOptionsToDisplay = variation.Options.concat(newOptions)
                      let optionWithImageFound = false;
                     const variationOptionsWithImages =selectOptionsToDisplay.map(option=>{
                         const variationOptionImage = GBGProductImages.find(image => {
                             const {ConditionsToMatch =[]}=image
                             if(ConditionsToMatch.find(conditionData=> {
                                 const {Conditions=[]} =conditionData
                                 return Conditions.find(condition => {
                                     return condition.VariationLabel == variation.Label && condition.OptionValue == option.value
                                 })
                             })){
                                 return image
                             }
                         })
                         if(variationOptionImage){
                             optionWithImageFound =true;
                         }
                         return {...option,variationOptionImage:variationOptionImage}
                     })
                     if (_.isUndefined(_.get(params, 'GBGProductToUse._id'))) {
                         selectOptionsToDisplay.push({
                             label: 'Add new option',
                             value: 'add_new_option'
                         })
                     }

                      return <div  key={index}>

                         <div   onClick={() => {
                                         self.setScreensData({
                                             'modelVariations': {
                                                 ...self.state.screensData.modelVariations,
                                                 [variation.Label + '###' + variation.type]: {
                                                     ..._.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type], {}),
                                                     optionsVisible: !_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'optionsVisible'], false)
                                                 }
                                             }
                                         })
                                     }}     className="top30 bot30 align-center text-center set-width cursor-pointer"  >



                             { _.capitalize(variation.Label) + ' ' + _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'selectedOptions', '0', 'label'], '')}
                          </div>
                             {(true ||   _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'optionsVisible'], false)) && (
                            <div className={'top10   text-left align-center ' + (optionWithImageFound ? '':'set-width')}>
                                {optionWithImageFound ?
                                  <div>{renderVariationOptionsWithImages.call(self,
                                    _.orderBy(variationOptionsWithImages, 'label', self.state.screensData.sortVariationOptions), {
                                    variation:variation,
                                    gbgProduct: self.state.screensData.selectedGBGProduct,
                                    showReportWrongUPC: self.ProductsSettingsData.addWrongUPCButton,
                                    imageClickHandler:( item)=>{
                                        self.setState({  showCustomContentModal: true})
                                        self.setScreensData({
                                            modalTitle:item.textLabel,
                                            modalType:'DisplayImageModal',
                                            imageToDisplay:item.imageURL
                                        })
                                    },
                                    itemClickHandler:(item)=> {
                                        const selectedOption = selectedOptions.length ? selectedOptions[0] : {}
                                        let selectedItems = [item]
                                        if(selectedOption.value == item.value){/*reset selected option if it is clicked again*/
                                            selectedItems = []
                                        }
                                         onModelVariationOptionSelect.call(self, {
                                            selectedOptions: selectedItems,
                                            label: variation.Label,
                                            variation: variation,
                                            onModelVariationOptionSelectCallback:()=>{},
                                             modelVariationType: variation.Label + '###' + variation.type,
                                            UseInTitle: variation.UseInTitle,
                                            AddTag: variation.AddTag,
                                            newOptions: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []),
                                            variationOptions: variationOptionsWithImages
                                        })
                                    }
                                  })}
                                      <div className=" top15 align-center text-center set-width cursor-pointer ">
                                      {_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'addNewOptionVisible'], false) ?

                                        <FaMinusCircle style={{color:Colors.purpleLighter2, position:'relative', top:-2}}   className=" right10 cursor-pointer  " onClick={() => {
                                            onModelVariationOptionSelect.call(self, {
                                                selectedOptions: [{value:'add_new_option'}],
                                                label: variation.Label,
                                                variation: variation,
                                                onModelVariationOptionSelectCallback:()=>{},
                                                modelVariationType: variation.Label + '###' + variation.type,
                                                UseInTitle: variation.UseInTitle,
                                                AddTag: variation.AddTag,
                                                newOptions: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []),
                                                variationOptions: variationOptionsWithImages
                                            })

                                          }} />:
                                          <FaPlusCircle style={{color:Colors.purpleLighter2,position:'relative',  top:-2}} className="right10  cursor-pointer  " onClick={() => {
                                              onModelVariationOptionSelect.call(self, {
                                                  selectedOptions: [{value:'add_new_option'}],
                                                  label: variation.Label,
                                                  variation: variation,
                                                  onModelVariationOptionSelectCallback:()=>{},
                                                  modelVariationType: variation.Label + '###' + variation.type,
                                                  UseInTitle: variation.UseInTitle,
                                                  AddTag: variation.AddTag,
                                                  newOptions: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []),
                                                  variationOptions: variationOptionsWithImages
                                              })
                                          }}  />} <span onClick={() => {
                                          onModelVariationOptionSelect.call(self, {
                                              selectedOptions: [{value:'add_new_option'}],
                                              label: variation.Label,
                                              variation: variation,
                                              onModelVariationOptionSelectCallback:()=>{},
                                              modelVariationType: variation.Label + '###' + variation.type,
                                              UseInTitle: variation.UseInTitle,
                                              AddTag: variation.AddTag,
                                              newOptions: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []),
                                              variationOptions: variationOptionsWithImages
                                          }) }} className="left10">Add new option</span>
                                      </div>
                                  </div>  :
                             <Select
                                 tabIndex="0"
                                 placeholder={variation.Label}
                                multi
                                 options={_.orderBy(selectOptionsToDisplay, 'label', self.state.screensData.sortVariationOptions)}
                                 onChange={(selectedOptions) => {
                                     onModelVariationOptionSelect.call(self, {
                                         selectedOptions: selectedOptions,
                                         label: variation.Label,
                                         variation: variation,
                                         //  variationImageURL:_.get(variation, 'VariationImages.0.URL',''),
                                         modelVariationType: variation.Label + '###' + variation.type,
                                         UseInTitle: variation.UseInTitle,
                                         AddTag: variation.AddTag,
                                         newOptions: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []),
                                         variationOptions: variationOptionsWithImages
                                     })
                                 }}

                                 value={_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'selectedOptions'], [])}
                             />}
                            </div>
                             )}
                         {_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'addNewOptionVisible'], false) && (
                             <div  className=" top10  align-center text-left set-width ">
                                 <FormControl

                                     placeholder={'Add new' + ' ' + variation.Label}
                                     value={_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptionLabel'], '')}

                                     onChange={(e) => self.setScreensData({
                                         'modelVariations': {
                                             ...self.state.screensData.modelVariations,
                                             [variation.Label + '###' + variation.type]: {
                                                 ..._.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type], {}),
                                                 newOptionLabel: e.target.value,
                                                 newOptionValue: e.target.value
                                             }
                                         }})}
                                     className="top10"
                                     type="text"/>


                                 <FormControl
                                     className="top10"
                                     componentClass="textarea"
                                     placeholder="Custom GBG Note"
                                     value={_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptionGBGNote'], '')}

                                     onChange={(e) => self.setScreensData({
                                         'modelVariations': {
                                             ...self.state.screensData.modelVariations,
                                             [variation.Label + '###' + variation.type]: {
                                                 ..._.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type], {}),
                                                 newOptionGBGNote: e.target.value
                                             }
                                         }})}
                                     type="text"/>
                                 <div className="top10 bot30 ">
                                     <Button

                                         disabled={!_.get(self.state.screensData.modelVariations[variation.Label + '###' + variation.type], 'newOptionValue', false) || !_.get(self.state.screensData.modelVariations[variation.Label + '###' + variation.type], 'newOptionLabel', false) }

                                         className="btn btn-lg btn-primary set-width "
                                         onClick={() => {
                                             var newOptionValue = _.get(self.state.screensData.modelVariations[variation.Label + '###' + variation.type], 'newOptionValue')
                                             var newOptionLabel = _.get(self.state.screensData.modelVariations[variation.Label + '###' + variation.type], 'newOptionLabel', '')
                                             var foundOption = _.find(_.concat(_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []), variation.Options), (option) => {
                                                 return newOptionValue == option.value || newOptionLabel == option.label
                                             })
                                             if (foundOption) {
                                                 displayMessage({
                                                     'messageType': 'warning',
                                                     'messageCode': 'This option already exists'
                                                 });
                                                 return;
                                             }
                                             self.setScreensData({
                                                 'modelVariations': {
                                                     ...self.state.screensData.modelVariations,
                                                     [variation.Label + '###' + variation.type]: {
                                                         ..._.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type], {}),
                                                         newOptions: _.concat(_.get(self.state.screensData.modelVariations[variation.Label + '###' + variation.type], 'newOptions', []), [{
                                                             label: newOptionLabel,
                                                             newSelectOption: true,
                                                             CustomGBGNote: _.get(self.state.screensData.modelVariations[variation.Label + '###' + variation.type], 'newOptionGBGNote', ''),
                                                             value: newOptionValue
                                                         }]),

                                                         newOptionLabel: '',
                                                         newOptionGBGNote: '',
                                                         newOptionValue: '',
                                                         addNewOptionVisible: false,
                                                     }
                                                 }
                                             }, () => {
                                                 onModelVariationOptionSelect.call(self, {
                                                     selectedOptions: [{
                                                         label: newOptionLabel,
                                                         value: newOptionValue
                                                     }],
                                                     label: variation.Label,
                                                     variation: variation,
                                                     //  variationImageURL:_.get(variation, 'VariationImages.0.URL',''),
                                                     modelVariationType: variation.Label + '###' + variation.type,
                                                     UseInTitle: variation.UseInTitle,
                                                     AddTag: variation.AddTag,
                                                     newOptions: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptions'], []),
                                                     variationOptions: variation.Options
                                                 })
                                             })



                                         }  }
                                     >Add new option
                                     </Button>
                                 </div>


                             </div>
                         )}
                     </div>
                 }

             }) }
         </div>)
     } else {
         return null
     }
 }
function renderVariationOptionsWithImages(options,params) {
     const gbgProductItem = params.gbgProduct
     const self = this
     const items = options.map(option=>{
         return {
            ...option,
            imageURL:option.variationOptionImage ? option.variationOptionImage.URL:false,
        }
    })
    return (
      <Row className="custom-image-grid --variation-options">

          {items.map((item, index) => {
              const {modelVariations = []} =this.state.screensData
                const {selectedOptions =[]} =modelVariations[params.variation.Label + '###' + params.variation.type] ? modelVariations[params.variation.Label + '###' + params.variation.type] : {}
                let optionSelected =false;

              if(selectedOptions.length && selectedOptions[0].value == item.value){
                  optionSelected = true;
              }

                 return <Col lg={3} md={4} sm={6} xs={12}
                          key={index}
                          onClick={()=>{
                              params.itemClickHandler(item)
                          }}
                          className="  top5 bot5    cursor-pointer pleft5 pright5">
                  <div className={'image-box ' + (optionSelected ? '--selected-image':'')} >
                      <div>
                          <img className=" "
                               style={{ width:120, height: 120}}   src={ item.imageURL ? item.imageURL :
                            (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') + '/theme/assets/no-image-available.png' }>
                          </img>
                          {item.imageURL &&
                            <svg  onClick={(e) => { /* from bootsrap-icons*/
                                e.stopPropagation()
                                e.preventDefault()
                                params.imageClickHandler(item, item.imageURL)
                            }} style={{position: 'absolute', top: 83, right: 14, fontSize: 30}}  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  className="bi bi-arrows-fullscreen cursor-pointer" viewBox="0 0 16 16">
                                <path fillRule="evenodd"
                                      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"/>
                            </svg>

                          }
                      </div>
                      <div className="left8 top10 text-left item-text-box">{item.label}
                      <div className=" purple">{item.CustomGBGNote}</div>
                      </div>
                  </div>
                  {
                    (self.ProductsSettingsData.addWrongUPCButton && optionSelected) && <ReportWrongUPCButton enabled={optionSelected} item={gbgProductItem} variation={item} reason="Variation Flagged" ></ReportWrongUPCButton>
                  }

              </Col>})}
      </Row>)
}
 export function  renderDimensionsVerticalView( pairOfItems) {
     return <div  >
             <div className=" "  >
                 {_.map(pairOfItems, (items) => {
                     return    <div   style={{justifyContent:'space-around',  }}  className=" flex-box top20"    key={items[0].label + _.get(items, '1.label', '')}>
                         {_.map(items, (item, index) => {
                             return <div  key={item.label}
                                          style={{ alignItems:'center', alignSelf:'center'}}     className="cursor-pointer"
                                                      onClick={(event) => {
                                                          var self = this;
                                                          var dataToUpdate = {
                                                              productDimensions: item.data
                                                          }
                                                          if(this.state.screensData.confirmDimensions == 'select_box_size'){
                                                              dataToUpdate.confirmDimensions = 'box_size_selected'
                                                          }
                                                         this.setScreensData(dataToUpdate, function () {
                                                              setTimeout(() => {
                                                                   self.setState({showCustomContentModal: false})

                                                              }, 1000)
                                                          })
                                                      }}>
                                 <div style={_.extend({}, (_.get(this.state.screensData, 'productDimensions.Width') == item.data.Width && _.get(this.state.screensData, 'productDimensions.Height') == item.data.Height && _.get(this.state.screensData, 'productDimensions.Length') == item.data.Length) ? {
                                     borderColor: 'grey'
                                 } : {})}>
                                     <img style={{width:150, height:150}} src={config.getEnvironment().serverBaseURL+'/'+item.imageSource}    />
                                     <div className="text-center top5" >{item.label}</div>

                                 </div>
                             </div>
                         })}
                     </div>
                 })}
             </div>

     </div>
 }
 function onModelVariationOptionSelect({selectedOptions, onModelVariationOptionSelectCallback =false,newOptions, label, variation, modelVariationType, UseInTitle = false, AddTag = true, variationOptions}) {
     var self = this;
      var selectedOption = _.size(selectedOptions) > 0 ? [_.last(selectedOptions)] : []
     if (_.get(selectedOption, '0.value') == 'add_new_option') {
         self.setScreensData({
             'modelVariations': {
                 ...self.state.screensData.modelVariations,
                 [variation.Label + '###' + variation.type]: {
                     ..._.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type], {}),
                     addNewOptionVisible: !_.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'addNewOptionVisible'], false),
                     newOptionGBGNote: _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptionGBGNote'], '') ? _.get(self.state.screensData.modelVariations, [variation.Label + '###' + variation.type, 'newOptionGBGNote'], '') : variation.defaultNewOptionGBGNote,
                 }
             }
         })
         return;

     }
     var foundOption = _.find(variationOptions, (variationOption) => {
         return variationOption.label == _.get(selectedOption, '0.label', 'n/a') && variationOption.value == _.get(selectedOption, '0.value', 'n/a')
     })
     if (!foundOption) { /* if not found, check in new options */
         foundOption = _.find(newOptions, (variationOption) => {
             return variationOption.label == _.get(selectedOption, '0.label', 'n/a') && variationOption.value == _.get(selectedOption, '0.value', 'n/a')
         })
     }
       var dataToUpdate = {
         'modelVariations': {
             ...this.state.screensData.modelVariations,
             [modelVariationType]: {
                 ..._.get(this.state.screensData.modelVariations, [modelVariationType], {}),
                 selectedOptions: selectedOption,
                 optionsVisible: onModelVariationOptionSelectCallback ? true  :  (selectedOptions.length > 0 ? false :true),
                   /* if onModelVariationOptionSelectCallback, to workaround display issue when option is deselected on PartnerProductSKU screen*/
                 label: label,
                 addNewOptionVisible:false,
                 //  selectedAt: new Date(),
                 //   variationImageURL:variationImageURL,
                 UseInTitle: UseInTitle,
                 AddTag: AddTag,
             }
         }
     }
     if (_.get(foundOption, 'CustomGBGNote', '')) {
         dataToUpdate.PersonalNote = _.get(foundOption, 'CustomGBGNote', '')
     }
     this.setScreensData(dataToUpdate, function () {

         var imagesToCheck = _.cloneDeep(_.filter(_.get(self.state.screensData, 'selectedGBGProduct.GBGProductImages', []), image => {
             return _.size(_.get(image, 'ConditionsToMatch', []))
         }))
         const {GBGProductImages=[]} = self.state.screensData.selectedGBGProduct

        let foundGBGProductImage = GBGProductImages.find(item => {
             return _.size(_.get(item, 'ConditionsToMatch', [])) == 0
             /* get default GBGProductImage*/
         })
         if(!foundGBGProductImage && GBGProductImages.length) {
              foundGBGProductImage = GBGProductImages[0]
         }
         let GBGProductImageToUpdate = foundGBGProductImage ? foundGBGProductImage.URL : ''

         var selectedModelVariations = _.filter(self.state.screensData.modelVariations, item => {
             return _.get(item, 'selectedOptions.0.value')
         })
           if (_.size(selectedModelVariations)) {
             _.forEach(selectedModelVariations, selectedModelVariation => {
                  _.forEach(imagesToCheck, image => {
                     var conditionMatched = _.find(image.ConditionsToMatch, conditionToMatch => {
                         // console.log('condition.VariationLabel ', _.get(conditionToMatch, 'Conditions.0.VariationLabel'), selectedModelVariation.label);
                         //    console.log('condition.OptionsValue ', _.get(conditionToMatch, 'Conditions.0.OptionValue'), _.get(selectedModelVariation, 'selectedOptions.0.value'));

                         return _.get(conditionToMatch, 'Conditions.0.VariationLabel') == selectedModelVariation.label && _.get(conditionToMatch, 'Conditions.0.OptionValue') == _.get(selectedModelVariation, 'selectedOptions.0.value')

                     })
                     if (conditionMatched) {
                         image.matchingConditionsCount = _.get(image, 'matchingConditionsCount', 0) + 1
                     }

                 })

                 var imagesSortedByMatchingCount = _.orderBy(_.filter(imagesToCheck, item => {
                     return _.get(item, 'matchingConditionsCount', 0) > 0
                 }), image => {
                     return image.matchingConditionsCount
                 }, 'desc')
                 console.log('imagesSortedByMatchingCount', imagesSortedByMatchingCount  );
                 if (_.size(imagesSortedByMatchingCount)) {
                     GBGProductImageToUpdate = _.get(imagesSortedByMatchingCount, '0.URL', '')
                 }
             })
         }


         self.setScreensData({GBGProductImage: GBGProductImageToUpdate})

         if (_.get(self, 'onModelVariationOptionSelectCallback')) {
             self.onModelVariationOptionSelectCallback.call(self)
         }


     })
 }

 export function prepareModelVariationsToSave() {
     console.log('prepareModelVariationsToSave');
     var GBGProductVariations = _.reject(_.map(_.get(this.state.screensData, 'modelVariations', []), function (modelVariationValue, modelVariationType) {
         // console.log('modelVariationType', modelVariationType  );
         if (_.get(modelVariationType.split('###'), ['1'], '') !== 'GBGProductVariation') {
             return {value: ''}
         }
         if (_.isUndefined(modelVariationValue.selectedOptions)) {
             return {
                 label: modelVariationValue.label,
                 UseInTitle: modelVariationValue.UseInTitle,
                 AddTag: modelVariationValue.AddTag,
                 value: _.get(modelVariationValue, ['value'], '')
             }
         } else {
             const firstSelectedOption = modelVariationValue.selectedOptions[0] || {value:''}
             return {
                 label: modelVariationValue.label,
                 UseInTitle: modelVariationValue.UseInTitle,
                 AddTag: modelVariationValue.AddTag,
                 newOptions: _.get(modelVariationValue, 'newOptions', []),
                 value: firstSelectedOption.value,
                 optionLabel: firstSelectedOption.label
             }
         }
     }), {'value': ''});
     var selectedCategoryVariations = _.reject(_.map(_.get(this.state.screensData, 'modelVariations', []), function (modelVariationValue, modelVariationType) {
         //  console.log('modelVariationType', modelVariationType  );
         if (_.get(modelVariationType.split('###'), ['1'], '') !== 'CategoryVariation') {
             return {value: ''}
         }
         if (_.isUndefined(modelVariationValue.selectedOptions)) {
             return {
                 label: modelVariationValue.label,
                 UseInTitle: modelVariationValue.UseInTitle,
                 AddTag: modelVariationValue.AddTag,
                 value: _.get(modelVariationValue, ['value'], '')
             }
         } else {
             return {
                 label: modelVariationValue.label,
                 UseInTitle: modelVariationValue.UseInTitle,
                 AddTag: modelVariationValue.AddTag,
                 value: _.get(modelVariationValue.selectedOptions, ['0', 'value'], '')
             }
         }
     }), {'value': ''});
     return GBGProductVariations.concat(selectedCategoryVariations)
 }
 export function renderItemsIncluded(stateData) {
      return <div className=""  >
         <FormControl
             ref={(ItemsIncludedInput) => {
                 if (ItemsIncludedInput && !this.ItemsIncludedInput) {
                     this.ItemsIncludedInput = ItemsIncludedInput;

                 }
             } }

             rows="5"
             componentClass="textarea"

             onFocus={() => {

                 if (_.get(stateData,'ItemsIncludedString','') == '') {
                     this.setScreensData({ItemsIncludedString: '\u25CF '})
                 }
             }}


             onKeyPress={(e) => {
                 var self = this;
                  if (e.nativeEvent.key == "Enter") {

                  //   console.log('self.ItemsIncludedInput', self.ItemsIncludedInput  );
                      setTimeout(function () {
                          self.setScreensData({ItemsIncludedString: stateData.ItemsIncludedString + '\n\u25CF '})

                      }, 0)
                 }


             }}

             value={stateData.ItemsIncludedString}
             //  selection={this.state.selection}
             //     onSelectionChange={ ({ nativeEvent: { selection } })=>{
             //     console.log('selectiong change', selection  );
             //     var self = this
             //     this.setState({selection:selection})
             //
             // }}
             onChange={e => {
 var val =e.target.value
                 // if (stateData.ItemsIncludedString == '') {
                 //     val = '\u25CF ' + val;
                 // }
                 if (val.substr(val.length - 3, 2).trim() === '\u25CF') {
                     val = val.substr(0, val.length - 1) + val.substr(val.length - 1).toUpperCase();
                 }
                  this.setScreensData({ItemsIncludedString: val})

                 // if (val.length == '') {
                 //     this.setState({ItemsIncludedString: '\u25CF '})
                 // } else {
                 //     this.setState({ItemsIncludedString: val})
                 // }
             }}
             placeholder='(optional)
- Bullet points of what is included
- e.g. accessories, bundled items, etc
'/>
     </div>

 }

 export function renderFeeList(stateData, feesToRender) {
     return <div >
         {feesToRender.map((item) => {
              var foundFeeIndex = _.findIndex(stateData.FeesToAdd, (fee) => {
                 return fee.feeType == item.feeType
             });

             const {amounts = []}  = item;
             return <div className='text-left' key={item.feeType}>
                 <Checkbox
                     onChange={() => {

                         if (foundFeeIndex == -1) {
                            this.setScreensData({
                                 FeesToAdd: _.concat(_.get(stateData,'FeesToAdd',[]), [item])
                             })
                         } else {
                            this.setScreensData({
                                 FeesToAdd: [...stateData.FeesToAdd.slice(0, foundFeeIndex),
                                     ...stateData.FeesToAdd.slice(foundFeeIndex + 1)]
                             })
                         }
                     }}

                     checked={ foundFeeIndex >= 0}>{ item.label + (item.additionalLabel ? item.additionalLabel : '')}</Checkbox>


                 {_.includes(['ReplacementPart', 'CleaningFee'], item.feeType) && foundFeeIndex >= 0 &&
                 <div  className="left20" >
                     {amounts.map((amount) => {
                         return  <Checkbox
                                 onChange={() => {
                                    this.setScreensData({
                                         FeesToAdd: [...stateData.FeesToAdd.slice(0, foundFeeIndex),
                                             {...stateData.FeesToAdd[foundFeeIndex], amount: amount},
                                             ...stateData.FeesToAdd.slice(foundFeeIndex + 1)]
                                     })
                                 }}

                                 checked={stateData.FeesToAdd[foundFeeIndex].amount == amount}>{'$' + amount}</Checkbox>

                     })}
                 </div>
                 }
             </div>
         })}

     </div>
 }
 export function prepareItemsIncludedData(stateData) {
     var ItemsIncluded = [], itemValue = ''
     //  console.log('ItemsIncludedString.length',   this.state.ItemsIncludedString.length   );
     _.forEach(stateData.ItemsIncludedString, (letter, key) => {
         // console.log('letter', letter, key, 'code:' + this.state.ItemsIncludedString.charCodeAt(key)   );

         if (stateData.ItemsIncludedString.charCodeAt(key) == '10') {
             return true;
             /* skip enter character */
         }
         if (stateData.ItemsIncludedString.charCodeAt(key) == '9679') {
             itemValue = _.trim(itemValue)
             if (itemValue) {
                 ItemsIncluded.push(_.trim(itemValue))
             }
             itemValue = ''
         } else {
             itemValue += letter;
         }
     })
     itemValue = _.trim(itemValue)
     /* include latest item */
     if (itemValue) {
         ItemsIncluded.push(_.trim(itemValue))
     }
     return ItemsIncluded
 }

 export async function calculateRecommendedPrices(params={OriginalPrice:''}, stateData) {
    //Necessary for tests for old CalculateRecommendePrices.

    const { EnableV5Pricing = [false] } = this.FeatureFlags;
    const userId = base64ToHex(this.props.userReducer.user._id, {convertToHEXUUID: true}).toLowerCase()

    if((EnableV5Pricing.includes(true) || EnableV5Pricing.includes(userId)) && !EnableV5Pricing.includes(false)) {
        return await calculateRecommendedPricesV5.call(this, params, stateData);
    } else if(this.FeatureFlags && this.FeatureFlags.EnableNewRecommendedPricesCalculation){
        return await newCalculateRecommendedPrices.call(this, params, stateData);
    }else{
        return oldCalculateRecommendedPrices.call(this, params, stateData);
    }
 }

 async function calculateRecommendedPricesV5(params, stateData) {
    const payload = {
        gbgProductId: stateData.selectedGBGProduct._id,
        gbgProductTags: stateData.selectedGBGProduct.GBGProductTags,
        categories: stateData.selectedGBGProduct.Categories,
        condition: params.Condition || stateData.Condition,
        selectedModelVariations: stateData.selectedModelVariations
    }

    const response = await this.props.makeRequest(payload, {
        "type": "post",
        "endpoint": "/v5/calculate-recommended-price/"
    })

    return response.data
 }

 async function newCalculateRecommendedPrices(params={OriginalPrice:''}, stateData) {
    const gbgProductIDConverted = base64ToHex(stateData.selectedGBGProduct._id, {convertToHEXUUID: true})
    let self = this;
    let formatedParams = {
        gbgProductID: gbgProductIDConverted,
        originalPrice: params.OriginalPrice,
        condition: params.Condition || stateData.Condition,
        allSimilarProducts: params.allSimilarProducts || stateData.allSimilarProducts || [],
        similarProducts: params.similarProducts || stateData.similarProducts || [],
        amazonProductFoundByASIN: _.isUndefined(_.get(stateData, ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice'])) && (stateData.selectedSearchAPIProduct || {}).AmazonProductFoundByASIN
    }
    console.log("========================PARAMS=============================")
    console.log(formatedParams)
    console.log("========================StateData=============================")
    console.log(stateData)
    let response = await this.props.makeRequest(formatedParams,{
            "type": 'post',
            "endpoint": "/calculate-recommended-price/",
        })
        let oldData = oldCalculateRecommendedPrices.call(this, params, stateData);

        console.log("========================NEW DATA=============================")
        console.log(response.data)

        console.log("========================OLD DATA=============================")
        console.log(oldData)

        console.log(`New: ${response.data.recommendedPrice}. Old:${oldData.recommendedPrice},  ${response.data.recommendedPrice == oldData.recommendedPrice}.`)

    return response.data
 }

function oldCalculateRecommendedPrices(params={OriginalPrice:''},stateData) {
    if(params.OriginalPrice =='' || _.isUndefined(params.OriginalPrice)){
        params.OriginalPrice = _.get(stateData, 'selectedGBGProduct.OriginalProductData.RetailProductPrice', '')
         if (!params.OriginalPrice) {
            params.OriginalPrice = _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice', '')
        }
    }

    const originalPrice = formatNumbers.unformat(params.OriginalPrice);
    let recommendedPrice
    let dataToUpdate = {}
    let sortedByMatchingProductNumber = []
    const selectedCondition = _.get(params, 'Condition',stateData['Condition'])
    let selectedConditionData = config.conditionsData.find(conditionData => conditionData.number == selectedCondition)

   if(!selectedConditionData){
        this.props.displayMessage({
           'messageType': 'warning',
           'messageCode': 'Can not calculate recommended price as condition data is not available'
       });
       return { recommendedPrice: ''}
   }
    let rawData = {
        GBGProduct: _.pick(_.get(stateData, 'selectedGBGProduct', {}), ['Brand', 'Model']),
        GBGProduct_AmazonProductPrice:  _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice', ''),
        GBGProduct_RetailProductPrice:  _.get(stateData, 'selectedGBGProduct.OriginalProductData.RetailProductPrice', ''),
        Condition: selectedConditionData.tag,
    }
    var increasePriceByPercent = false,
        allSimilarProducts = _.get(params, 'allSimilarProducts', _.get(stateData, ['allSimilarProducts'], []))

    var allSaleTransactions = []
    _.forEach(allSimilarProducts, function (item) { /* allSimilarProducts is empty if it is bundle as getSimilarProducts is not called for bundles*/

        if (item.PublishedInShopifyAt) {

            allSaleTransactions = _.concat(allSaleTransactions, _.map(_.filter(_.get(item, 'SaleTransactionRecords', []), function (transaction) {
                return transaction.Status !== 'Returned'
            }), transaction => {
                return {...transaction, ProductPublishedInShopifyAt: item.PublishedInShopifyAt}
            }))
        }

    })

    var lastTwoSaleTransactions = _.orderBy(allSaleTransactions, function (item) {
         return item.createdAt
    }, 'asc').slice(-2)

    if (lastTwoSaleTransactions.length == 2) {
         /* check if two last sale transactions were created within 2 or 10 days after published this product in Shopify */
        _.forEach(lastTwoSaleTransactions, saleTransaction => {
            const productPublishedInShopifyAt = moment(saleTransaction.ProductPublishedInShopifyAt);
            const salesTwoDayWindow = moment(saleTransaction.ProductPublishedInShopifyAt).add(2, 'days').endOf('day')
            if (moment(saleTransaction.createdAt).isBetween(productPublishedInShopifyAt, salesTwoDayWindow) ) {
                  saleTransaction.soldWithinTwoDays = true
            }
        })
        _.forEach(lastTwoSaleTransactions, saleTransaction => {
            const productPublishedInShopifyAt = moment(saleTransaction.ProductPublishedInShopifyAt);
            const salesTenDayWindow = moment(saleTransaction.ProductPublishedInShopifyAt).add(10, 'days').endOf('day')
            if (moment(saleTransaction.createdAt).isBetween(productPublishedInShopifyAt, salesTenDayWindow) ) {
                 saleTransaction.soldWithinTenDays = true
            }
        })
         if (_.every(lastTwoSaleTransactions, {soldWithinTenDays: true})) {
            increasePriceByPercent = 5
        }
        if (_.every(lastTwoSaleTransactions, {soldWithinTwoDays: true})) {
            increasePriceByPercent = 10
        }

    }
    _.extend(rawData, {
        SaleTransactions :allSaleTransactions,
        lastTwoSaleTransactions:lastTwoSaleTransactions
    })
    var similarProducts = _.get(params, 'similarProducts', _.get(stateData, ['similarProducts'], []))

    var  similarProductsWithTheSameCondition = _.filter(similarProducts, item => {
        return item.Condition == selectedConditionData.tag
    })
    const  similarProductsInDifferentCondition  =  similarProducts.filter(item => {
         return  item.SimilarProductStatus == 'Live' && item.Condition && item.Condition !== selectedConditionData.tag
    })

     let recommendedPriceBasedOnCondition = null;
    if ( selectedCondition == 0) {
        if (originalPrice <= 100) {
            recommendedPriceBasedOnCondition = formatNumbers.toFixed(.75 * originalPrice, 0)
        } else {
            recommendedPriceBasedOnCondition = formatNumbers.toFixed(.8 * originalPrice, 0)
        }
    } else { /* if condition is not Brand New, apply percent value for selected condition */
            recommendedPriceBasedOnCondition = formatNumbers.toFixed(selectedConditionData.percent * originalPrice, 0)
    }

    if (_.get(stateData, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle') {
        recommendedPriceBasedOnCondition = formatNumbers.toFixed(selectedConditionData.percentBundles * originalPrice, 0)
    }

    _.extend(rawData, {
        SaleTransactions :_.map(allSaleTransactions, item=>{
            return _.pick(item,['Amount'])
        }),
        lastTwoSaleTransactions:_.map(lastTwoSaleTransactions, item=>{
            return _.pick(item,['Amount'])
        }),
        similarProductsInDifferentCondition:    _.map(similarProductsInDifferentCondition, item=>{
            return _.pick(item,['Condition','Price'])
        }),
        similarProductsWithTheSameCondition:    _.map(similarProductsWithTheSameCondition, item=>{
            return _.pick(item,['Condition', 'Price'])
        }),
        recommendedPriceBasedOnCondition: recommendedPriceBasedOnCondition
    })



    recommendedPrice=recommendedPriceBasedOnCondition

    if ( similarProductsInDifferentCondition.length){/* if similar products in different condition exists*/
        if( similarProductsInDifferentCondition.length ==1){
            var Condition = _.get(similarProductsInDifferentCondition, '0.Condition')
            if (_.includes(_.get(similarProductsInDifferentCondition, [0,'ProductTags'], []), 'with issues')) {
                if (Condition == 'Gently Used') {
                    Condition = 'GentlyUsedMinorIssues'
                } else if (Condition == 'Open Box') {
                    Condition = 'OpenBoxMinorIssues'
                }
            }
            var recommendedPriceForSimilarProduct
            var conditionData = _.find(config.conditionsData, {value:Condition})

            if ( _.get(conditionData, 'number') == 0) {
                if (originalPrice <= 100) {
                    recommendedPriceForSimilarProduct = formatNumbers.toFixed(.75 * originalPrice, 0)
                } else {
                    recommendedPriceForSimilarProduct = formatNumbers.toFixed(.8 * originalPrice, 0)
                }

            } else { /* if condition is not Brand New, apply percent value for selected condition */
                if (_.includes(_.get(similarProductsInDifferentCondition, [0,'ProductTags'], []), 'hotBuy')) {
                    recommendedPriceForSimilarProduct = formatNumbers.toFixed(conditionData['percentHotBuy'] * originalPrice, 0)
                } else {
                    recommendedPriceForSimilarProduct = formatNumbers.toFixed(conditionData['percent'] * originalPrice, 0)
                }
            }

            if (_.get(similarProductsInDifferentCondition, [0,'Brand'], '').toLowerCase() == 'bundle') {
                recommendedPriceForSimilarProduct = formatNumbers.toFixed(conditionData['percentBundles'] * originalPrice, 0)
            }
            var priceDifference = Math.abs(similarProductsInDifferentCondition[0].Price - recommendedPriceForSimilarProduct)
             var priceDifferenceInPercent = (priceDifference / recommendedPriceForSimilarProduct) * 100
             var adjustPriceAction = (a, b) => {
                return a - b
            }
            if ((similarProductsInDifferentCondition[0].Price -recommendedPriceForSimilarProduct) > 0) {
                adjustPriceAction = (a, b) => {
                    return a + b
                }
            }
            recommendedPrice = adjustPriceAction( parseFloat(recommendedPriceBasedOnCondition) ,  parseFloat(recommendedPriceBasedOnCondition / 100 * formatNumbers.toFixed(priceDifferenceInPercent)))
         }else{/* more than 1*/
             var pricesOrdered =_.orderBy(similarProductsInDifferentCondition,(similarProduct) =>{

                var conditionData = _.find(config.conditionsData, {value:similarProduct.Condition}),recommendedPriceForSimilarProduct =0
                if ( _.get(conditionData, 'number') == 0) {
                    if (originalPrice <= 100) {
                        recommendedPriceForSimilarProduct = formatNumbers.toFixed(.75 * originalPrice, 0)
                    } else {
                        recommendedPriceForSimilarProduct = formatNumbers.toFixed(.8 * originalPrice, 0)
                    }

                } else { /* if condition is not Brand New, apply percent value for selected condition */
                    if (_.includes(_.get(similarProduct, ['ProductTags'], []), 'hotBuy')) {
                        recommendedPriceForSimilarProduct = formatNumbers.toFixed(conditionData['percentHotBuy'] * originalPrice, 0)
                    } else {
                        recommendedPriceForSimilarProduct = formatNumbers.toFixed(conditionData['percent'] * originalPrice, 0)
                    }
                }
                if (_.get(similarProduct, ['Brand'], '').toLowerCase() == 'bundle') {
                    recommendedPriceForSimilarProduct = formatNumbers.toFixed(conditionData['percentBundles'] * originalPrice, 0)
                }

                var priceDifference = Math.abs(similarProduct.Price - recommendedPriceForSimilarProduct)
                var priceDifferenceInPercent = (priceDifference / recommendedPriceForSimilarProduct) * 100
                similarProduct.recommendedPriceForSimilarProduct =recommendedPriceForSimilarProduct
                similarProduct.priceDifferenceInPercent =parseFloat(formatNumbers.toFixed(priceDifferenceInPercent,2))
                return similarProduct.priceDifferenceInPercent
            }, 'asc')
            var adjustPriceAction = (a, b) => {
                return a - b
            }
            if ((_.get(pricesOrdered,[0,'Price']) -_.get(pricesOrdered,[0,'recommendedPriceForSimilarProduct'])) > 0) {
                adjustPriceAction = (a, b) => {/* if actual price is greater than recommended price based on condition*/
                    return a + b
                }
            }
            recommendedPrice = adjustPriceAction( parseFloat(recommendedPriceBasedOnCondition) ,  parseFloat(recommendedPriceBasedOnCondition / 100 * formatNumbers.toFixed(_.get(pricesOrdered,[0,'priceDifferenceInPercent']))))
        }
    }

    if (similarProductsWithTheSameCondition.length    ){
        let  liveItemPrices = [];
        let soldWithinLast6MonthsPrices = [];
        let  soldMoreThan6MonthsAgo = [];
        let priceForSimilarProducts = 'initial';
        let timeMonthsAgo = moment().subtract(6, 'months');

         _.forEach(similarProductsWithTheSameCondition, function (item) {
            if (item.SimilarProductStatus == 'Live') { /* Get prices for all Live items that were not sold and have quantity of more than 0   */

                var foundPrice = _.find(liveItemPrices, {Price: item.Price})
                if (foundPrice) {
                    foundPrice.count++
                } else {
                    liveItemPrices.push({Price: item.Price, count: 1})
                }
            } else if (item.SimilarProductStatus == 'Sold') { /* these products can be both Active and Inactive */
                if (moment(item.SimilarProductSoldAt).isAfter(timeMonthsAgo, 'day')) {
                     var foundPrice = _.find(soldWithinLast6MonthsPrices, {Price: item.Price})
                    if (foundPrice) {
                        foundPrice.count++
                    } else {
                        soldWithinLast6MonthsPrices.push({Price: item.Price, count: 1})
                    }
                } else if (moment(item.SimilarProductSoldAt).isBefore(timeMonthsAgo, 'day') ) {
                     var foundPrice = _.find(soldMoreThan6MonthsAgo, {Price: item.Price})
                    if (foundPrice) {
                        foundPrice.count++
                    } else {
                        soldMoreThan6MonthsAgo.push({Price: item.Price, count: 1})
                    }
                }
            }
        })

        if (_.size(liveItemPrices)) {
            sortedByMatchingProductNumber = _.orderBy(liveItemPrices, ['count'], 'desc')
        } else if (_.size(soldWithinLast6MonthsPrices)) {
            sortedByMatchingProductNumber = _.orderBy(soldWithinLast6MonthsPrices, ['count'], 'desc')
        } else if (_.size(soldMoreThan6MonthsAgo)) {
            sortedByMatchingProductNumber = _.orderBy(soldMoreThan6MonthsAgo, ['count'], 'desc')
        }
        if (sortedByMatchingProductNumber.length) {
             if (_.get(sortedByMatchingProductNumber, '0.count', 0) > 1 && sortedByMatchingProductNumber[0].count > _.get(sortedByMatchingProductNumber, '1.count', 0)) {
                /* if most often price (mode) is found, use it */
                priceForSimilarProducts = _.get(sortedByMatchingProductNumber[0], 'Price')
            }
             if (priceForSimilarProducts == 'initial') { /* if mode price is not found, find median price  */
                var matchingSimilarProducts = []
                _.forEach(sortedByMatchingProductNumber, product => {
                    if (product.count == 1) {
                        matchingSimilarProducts.push(product)
                    } else {
                        for (var i = 0; i < product.count; i++) {
                            matchingSimilarProducts.push(product)
                        }
                    }
                })

                var itemsInAscOrder = _.orderBy(matchingSimilarProducts, ['Price'], ['asc'])
                var middle = Math.floor(itemsInAscOrder.length / 2);
                if (itemsInAscOrder.length % 2) {
                    priceForSimilarProducts = _.get(itemsInAscOrder[middle], 'Price')
                } else {/*   even number of products  */
                    priceForSimilarProducts = ( _.get(itemsInAscOrder[middle - 1], 'Price') + _.get(itemsInAscOrder[middle], 'Price')) / 2
                }
            }

            if (_.get(stateData, 'selectedSearchAPIProduct.AmazonProductFoundByASIN', false) && _.isUndefined(_.get(stateData, ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice']))) { /*  if we get original price from found Amazon product and RetailProductPrice is undefined as it overrides found Amazon product price in getAmazonProductData */
                /* if original price from found Amazon product differs by more than 10% from   AmazonProductPrice stored GBG product, update average price for similar products   by this percent */
                var priceDifference = Math.abs(originalPrice - _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice', originalPrice))
                if (priceDifference > 0 && priceDifference < 150) {
                    var priceDifferenceInPercent = (priceDifference / _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice', originalPrice)) * 100
                    // console.log('Found by ASIN', formatNumbers.toFixed(priceDifferenceInPercent), originalPrice, _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice', 'not available'));
                    if (formatNumbers.toFixed(priceDifferenceInPercent) >= 10) {
                        var action = (a, b) => {
                            return a - b
                        }
                        if ((originalPrice - _.get(stateData, 'selectedGBGProduct.OriginalProductData.AmazonProductPrice', originalPrice)) > 0) {
                            action = (a, b) => {
                                return a + b
                            }
                        }
                        priceForSimilarProducts = action(parseFloat(priceForSimilarProducts), parseFloat(priceForSimilarProducts / 100 * formatNumbers.toFixed(priceDifferenceInPercent)))
                    }
                }
            }
             if (_.size(liveItemPrices) || similarProductsInDifferentCondition.length ==0) {
                 /* if similarProductsInDifferentCondition exists, recommendedPrice was set based on them and it overrides recommended price set on sold products in the same condition*/
                recommendedPrice = formatNumbers.toFixed(priceForSimilarProducts, 2)
            }
        }
    }

    if (increasePriceByPercent) {
        dataToUpdate.HotBuyOverride = true
        recommendedPrice = formatNumbers.unformat(recommendedPrice) + ((recommendedPrice / 100) * increasePriceByPercent)
    }

    const maxRecommendedPrice = (this.FeatureFlags.SetMaxRecommendedPriceTo80) ?
        formatNumbers.toFixed(.80 * originalPrice, 2) :
        formatNumbers.toFixed(.95 * originalPrice, 2)

    /* recommended price should not be more than 95% or 80% of retail*/
    /* maxRecommendedPrice can be 0 when originalPrice is set as 0 when calling from QualityChecks */
    if (parseInt(maxRecommendedPrice) !== 0 && parseInt(maxRecommendedPrice) < parseInt(recommendedPrice)) {
        recommendedPrice = maxRecommendedPrice
    }
    recommendedPrice = applyRoundRules(recommendedPrice)
     return {dataToUpdate: dataToUpdate, calculateRecommendedPriceData:rawData, recommendedPrice: recommendedPrice}
}

export function applyRoundRules(price) {
    var roundedPrice = formatNumbers.toFixed(formatNumbers.unformat(price))
    /* round to the nearest whole number, by default precision of 0 is used*/
//console.log('roundedPrice', roundedPrice  );
    if (roundedPrice < 7) {
        return formatNumbers.formatMoney(price, '$', 0);
    }
    if (formatNumbers.unformat(price) > 14 && formatNumbers.unformat(price) < 15) {
        return '$15'
    }
    var lastDigitInPrice = roundedPrice.length > 1 ? roundedPrice.slice(-1) : roundedPrice
    if (_.includes(['7', '8', '9'], lastDigitInPrice)) {
        return '$' + roundedPrice.slice(0, roundedPrice.length - 1) + '9.99'
        /* replace last digit with 9*/
    } else if (_.includes(['0', '1'], lastDigitInPrice)) {
        return '$' + (roundedPrice - (parseInt(lastDigitInPrice) + 1)) + '.99'
    } else {
        return formatNumbers.formatMoney(price, '$', 0);
    }
}
export function getSelectedCategories(categories, includeGBGProducts = false) {
    var selectedCategories = [], component = this;
    _.forEach(categories, function (category) {
        if (category.selected) {  /* if top-level category is selected*/
            // if (includeGBGProducts){
            //     var matchingGBGProducts = getGBGProductsForCategory.call(component, category.TagName)
            //     category.GBGProducts= matchingGBGProducts
            // }
            selectedCategories.push(category)
            /* do not select subcategories, when only top-level category is selected */
            // if (withSubcategories) {
            //     _.forEach(category.subCategories, function (subcategory) {
            //         selectedCategories.push(subcategory)
            //     })
            // }
        }
        _.forEach(category.subCategories, function (subcategory) {
            if (subcategory.selected) {

                // if (includeGBGProducts){
                //     var matchingGBGProducts = getGBGProductsForCategory.call(component, category.TagName,subcategory.TagName)
                //     // console.log('matchingGBGProducts subcategory', matchingGBGProducts  );
                //     subcategory.GBGProducts= matchingGBGProducts
                // }
                selectedCategories.push({...subcategory, topLevelCategoryID: category._id})
            }
        })

    })
    return selectedCategories
}
export function prepareProductCategories(data) {
    var GBGProductCategories = []

    if (_.get(data, 'selectedGBGProduct._id')) {
        _.forEach(_.get(data, 'selectedGBGProduct.Categories', []), function (item) {
            var foundTopLevelCategory = _.find(data.AllCategories, function (categoryRecord) {
                return categoryRecord.TagName == item.Category
            })

            if (foundTopLevelCategory) {
                if (item.Subcategory) {
                    var foundSubcategory = _.find(foundTopLevelCategory.subCategories, function (categoryRecord) {
                        return categoryRecord.TagName == item.Subcategory
                    })
                    if (foundSubcategory) {
                        GBGProductCategories.push({
                            Category: item.Category,
                            Subcategory: item.Subcategory
                        })
                        // dataToSave.Subcategories = [item.Subcategory]
                        /* to assign them as Category and Subcategory to product record */
                        //dataToSave.ProductTags.push(item.Category)
                        //  dataToSave.ProductTags.push(item.Subcategory)
                    }
                } else {
                    //dataToSave.ProductTags.push(item.Category)
                    GBGProductCategories.push({Category: item.Category})
                }
            }
        }.bind(this))
    }
    var CategoriesTags = _.map(_.get(data, 'selectedCategories', []), function (selectedCategory) {
        if (_.isUndefined(selectedCategory.topLevelCategoryID)) { /* it is top-level category */
            return {Category: selectedCategory.TagName}
        } else {  /*it is subcategory, add its top-level category tag */
            // dataToSave.Subcategories = [selectedCategory.TagName]
            return {
                Category: _.find(data.AllCategories, {'_id': selectedCategory.topLevelCategoryID}).TagName,
                Subcategory: selectedCategory.TagName
            }
        }
    }.bind(this))

    // var topLevelCategories = _.map(_.filter(allCategories, item=>{
    //     return _.isUndefined(item.Subcategory)
    // }), item=>{
    //     return item.Category
    // })
    return _.chain(_.concat(CategoriesTags, GBGProductCategories))
    // .reject(function (item) {
    //      return _.includes(topLevelCategories,item.Category) && item.Subcategory /* exclude items with Subcategory, if it has the same Category  as other item with only Category value */
    //  })
        .uniqBy(function (item) {
            return item.Category + (item.Subcategory ? item.Subcategory : '')
        })
        .sortBy(function (item) {
            return item.Category + (item.Subcategory ? item.Subcategory : '')
        })
        .value();
}
 export function  processVariationsForPallets() {
     var self = this, functionsToCall = [],AddVariationsRequestID = uuidv4()

     this.setState({pending: true});
     var totalQuantity = _.reduce(this.state.screensData.palletProductsToAdd, function (total, item) {
         return total += parseInt(item.Quantity)
     }, 0)
     var COGsForAllOriginalProducts =  _.get(self.state.screensData, 'CurrentProductData.PalletProductData.WhatWePaidToUnit',0) * _.get(self.state.screensData, 'CurrentProductData.PalletProductData.Quantity',0)
     /* ‘What we paid’ is $8 and Quantity is 5$. If user updates quantity to 6, new COGS will  be $40/6 = $6.67 */
     if (COGsForAllOriginalProducts == 0) {
         self.setState({pending: false});
         return self.props.displayMessage({
             'messageType': 'warning',
             'messageCode': 'Can not calculate updated COGs value'
         });
     }
     var COGSToUpdate= formatNumbers.toFixed(COGsForAllOriginalProducts / totalQuantity, 2)

     if (_.size(this.state.screensData.palletProductsToAdd) > 1) {
         functionsToCall.push(function (done) {
             var methodData = {
                 "endpoint": "/pallets" + '/' + encodeURIComponent(_.get(self.state.screensData, ['CurrentProductData', 'PalletID', '_id'])) + '/import-pallet-product-variations',
                 type: "patch",
                 timeout: 65000,
             };
             self.props.makeRequest({
                 productsToImport: _.map(self.state.screensData.palletProductsToAdd.slice(1), item => {
                     return {
                         ...item,COGS:COGSToUpdate,
                         TotalCOGS:_.get(self.state.screensData, ['CurrentProductData', 'TotalCOGS']),
                         ProductVariantQuantity:item.Quantity,
                         PalletProductData: {
                             ..._.omit(_.get(self.state.screensData, ['CurrentProductData', 'PalletProductData'], {}), []),
                             PalletProductStatus:'Checked'
                         },
                         CustomData: {
                             AddVariationsRequestID:AddVariationsRequestID  },



                     }
                 })
             }, methodData).then(resp => {
                 done(null)
             }).catch(err => {
                 done(err)
             })
         })
     }
     functionsToCall.push(function (done) {
         let ProductItems = self.state.screensData.CurrentProductData.ProductItems || []
         const firstItem = _.first(self.state.screensData.palletProductsToAdd)
         let dataToUpdate = {
             Quantity:firstItem.Quantity,
             CustomData:{
                 MainVariation:true,
                 AddVariationsRequestID:AddVariationsRequestID
             },
             COGS:COGSToUpdate,
             ProductNameToOverride:firstItem.ProductName,
             PalletProductData: {
                 PalletProductStatus: 'Checked'
             }
         }
          if(ProductItems.length > 0) {
              if (firstItem.Quantity < ProductItems.length) {/* remove extra product items*/
                  dataToUpdate.ProductItemsToUpdate = ProductItems.slice(0, firstItem.Quantity)
              } else if (firstItem.Quantity > ProductItems.length) { /* add new product items*/
                  dataToUpdate.ProductItemsToUpdate = [...ProductItems]
                  const {SKU = ''} = self.state.screensData.CurrentProductData
                  const currentSKUmatch = SKU.match(/^(\d+\.\d+\.\d+)(-.*)?$/s)
                  const SKUBase = currentSKUmatch && currentSKUmatch[1] ? currentSKUmatch[1] : 'SKU_na'
                  let lastLocationNumber = _.orderBy(ProductItems.map(function (item) {
                      const {ProductItemSKU = ''} = item
                      const productItemSKUMatch = ProductItemSKU.match(/^\d+\.\d+\.\d+\.(\d+)(-.*)?/)
                      const SKUNumber = productItemSKUMatch && productItemSKUMatch[1] ? productItemSKUMatch[1] : 0
                      return parseInt(SKUNumber)
                  }), number => {
                      return number
                  }, 'desc')[0]
                  _.range(0, firstItem.Quantity - ProductItems.length).forEach(index => {
                      lastLocationNumber = lastLocationNumber + 1
                      let ProductItemSKUToAdd = SKUBase + '.' + lastLocationNumber
                      dataToUpdate.ProductItemsToUpdate.push({
                          ProductItemID: uuidv4(),
                          ProductItemSKU: ProductItemSKUToAdd
                      })
                  })
              }
          }

         self.props.makeRequest(dataToUpdate, {
             /* update the main listing */
             'endpoint': '/products/' + encodeURIComponent(_.get(self.state.screensData, ['CurrentProductData', '_id'], 'n/a')),
             'not_display_success_message': true,
             type: 'patch',
         }).then(function (resp) {
             self.setState({pending: false});

             done(null)
         }).catch(err => {
             done(err)
         });
     })

     async.series(functionsToCall,
         function (err, responses) {
             self.setState({pending: false});
             if (!err) {
                 self.props.displayMessage({
                     'messageCode': 'Product variations updated'
                 });
                 self.resetScreensData()
             }
         })
 }

function getGBGProductImageToDisplay(GBGProduct) {
  const { GBGProductImages = [], UPCCodeRecord = {} } = GBGProduct;

  let GBGProductImage = GBGProductImages.find((item) => {
    const { ConditionsToMatch = [] } = item;
    return ConditionsToMatch.length == 0;
  });
  const { VariationLinks = [] } = UPCCodeRecord;

  if (VariationLinks.length) {
    const imagesToCheck = _.cloneDeep(
      GBGProductImages.filter((image) => image.ConditionsToMatch && image.ConditionsToMatch.length)
    );
    const foundVariationLinkImage = imagesToCheck.find((image) => {
       return (image.ConditionsToMatch || []).find((conditionToMatch) => {
            const {Conditions = []} = conditionToMatch;

            if (Conditions.length) {
                return VariationLinks.find(
                  (variationLInk) =>
                    Conditions[0].VariationLabel == variationLInk.VariationLabel &&
                    Conditions[0].OptionValue == variationLInk.VariationOptionValue
                );
            }
        });
    });

    if (foundVariationLinkImage) {
      GBGProductImage = foundVariationLinkImage;
    }
  }

  if (!GBGProductImage && GBGProductImages.length > 0) {
    /* if all images have ConditionsToMatch, use the first photo */
    GBGProductImage = GBGProductImages[0];
  }

  return GBGProductImage;
}

export function displayGBGProductsInGrid(GBGProductsData, params) {
        const self = this;
        const {RMAProductsData = {}} = params.screensData;
        const {RMAProducts = []} = RMAProductsData;
        const items = GBGProductsData.map(GBGProduct=>{
        const { GBGProductImages = [], UPCCodeRecord = {} } = GBGProduct;
        GBGProduct.GBGProductImage = getGBGProductImageToDisplay(GBGProduct);
        const matchingRMAProducts = RMAProducts.filter((item) => {
          if(item.RMAProductStatus == 'rma_created' && isPartner(GBGProduct.Brand)) {
              if(item.GBGProductID && hexToBase64(item.GBGProductID) == GBGProduct._id) {
                  return true;
              }

              if(item.GBGProductModel && item.GBGProductModel == GBGProduct.Model) {
                  return true;
              }
          }
        });
        return {
         ...GBGProduct,
          matchingRMAProducts,
         imageURL:GBGProduct.GBGProductImage ? GBGProduct.GBGProductImage.URL : false,
          textLabel :(GBGProduct.Brand == 'Unknown' ? '' : GBGProduct.Brand + ' ') + GBGProduct.Model,
          UPCCode:UPCCodeRecord.UPCCode ? UPCCodeRecord.UPCCode : '',
        itemImages:GBGProductImages,
        };
     })

    return (<Row className="custom-image-grid">
          {items.map((item, index) => {
              return <Col data-testid='custom-image-grid-item' lg={3} md={4} sm={6} xs={12}
              key={index}
              onClick={()=>{
                  if(self.state.pending) {
                      return;
                  }
                  params.itemClickHandler(item)
              }}
              className="  top5 bot5    cursor-pointer pleft5 pright5">
                     <div className={'image-box'}>
                      <div>
                     <img className=" "
                          style={{ width:100, height: 100}}   src={ item.imageURL ? item.imageURL :
                         (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') + '/theme/assets/no-image-available.png' }>
                     </img>
                          {item.imageURL &&
                            <svg  onClick={(e) => {/* from bootsrap-icons*/
                                e.stopPropagation()
                                e.preventDefault()
                                params.imageClickHandler(item, item.imageURL)
                            }}  style={{position: 'absolute', top: 83, right: 14, fontSize: 30}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 className="bi bi-arrows-fullscreen cursor-pointer" viewBox="0 0 16 16">
                                <path fillRule="evenodd"
                                      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"/>
                            </svg>

                          }
                      </div>
                     <div className="left8 top10 text-left item-text-box ">
                         {item.UPCCode !== '' && <div className="text-bold text-left  green">  {item.UPCCode} </div>}
                         <span>{item.textLabel}</span>
                     </div>
                     </div>
                      {item.matchingRMAProducts.length > 0 && <div className='left12'>
                          <span>RMA Products:</span>
                           <ol className="top10 pleft8">
                          { item.matchingRMAProducts.map(item=> {
                              const {RMAVendorMetaData = {}}  = item;
                               return <li className="text-bold">
                                  <div>{`${item.RMAProductBrand} ${item.RMAProductModel}`}</div>
                                   {!_.isUndefined(RMAVendorMetaData.arktx) && <div className="orange">{RMAVendorMetaData.arktx}</div>}
                                  </li>;
                          })}
                           </ol>
                      </div>}
                     { (self.ProductsSettingsData.addWrongUPCButton && item.UPCCodeRecord) &&
                     <ReportWrongUPCButton item={item} reason="GBG Product Flagged" ></ReportWrongUPCButton>
                    }
                 </Col>})}
       </Row>)
}

export function getNextScreenName(params) {
    let nextScreen;
    const self = this;

    switch (params.currentScreen) {
        case SCREENS.fees_screen.key:
            nextScreen = SCREENS.confirmation_screen.key;
            const {CurrentPartnerProductData = {}} = this.state.screensData;

            if (this.state.currentFlow == 'PostingFlow') {
                nextScreen =  SCREENS.location_scanning_screen.key;

                if (self.props.appData.FeatureFlags.WarehouseLocationScreenDisabled) {
                    nextScreen = SCREENS.confirmation_screen.key;
                }
            } else if (self.state.currentFlow == '3PLProcessingFlow' && CurrentPartnerProductData._id) {
                nextScreen = SCREENS.location_scanning_screen.key;
            }

            break;
        default:
    }

    return nextScreen;
}
